/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
/* eslint-disable max-len */
export const DE_DE = {
    'test': 'test-test',  // unit test do not delete
    'test_with_two_parameters': 'Test {{placeholder1}} test2 {{placeholder2}}', // unit test do not delete
    'color': 'Farbe',

    '403_access_denied': 'Zugriff verweigert',
    '404': '404: Seite fehlt',
    '404_page_not_found': 'Seite nicht gefunden',
    'Required': 'Erforderlich', // Has capital key for validation component
    'account_enter_current_password': 'Bitte geben Sie Ihr aktuelles Passwort ein, um fortzufahren.',
    'account_private_key_message': 'Ihr Schlüssel ist einzigartig für Sie. Die Wiederherstellung des Passworts hängt von seiner Validierung ab und erfordert daher, dass Sie ihn herunterladen und an einem sicheren Ort speichern.',
    'accounts_download_key': 'Schlüssel herunterladen',
    'accounts_password_message': 'Lassen Sie die Felder leer, wenn Sie das Passwort nicht ändern möchten',
    'accounts_recover_password': 'Passwort zurücksetzen',
    'accounts_recover_password_complete_redirect_message': 'Zur Anmeldeseite des Portals gehen',
    'accounts_recover_password_email_label': 'Registrierte E-Mail',
    'accounts_recover_password_intro': 'Um Ihr Passwort zurückzusetzen, geben Sie bitte Ihre registrierte E-Mail-Adresse und Ihren privaten Benutzerschlüssel ein.',
    'accounts_recover_password_intro_2': 'Geben Sie nun Ihr neues Passwort unten ein.',
    'accounts_recover_password_redirect_login': 'Zurück zur Anmeldeseite',
    'accounts_recover_password_upload_org_message': 'Wählen Sie Ihren privaten Organisationsschlüssel aus',
    'accounts_recover_password_upload_user_message': 'Wählen Sie Ihren privaten Benutzerschlüssel aus',
    'accounts_recovery_download_key': 'Privaten Schlüssel herunterladen',
    'accounts_recovery_download_key_org': 'Organisationsschlüssel herunterladen',
    'accounts_recovery_download_success_message': 'erfolgreich heruntergeladen',
    'accounts_recovery_keep_keys_safe': 'Bitte bewahren Sie Ihre Schlüssel an einem sicheren Ort auf!',
    'accounts_recovery_keep_keys_safe_message': 'Wenn Sie Ihre Anmeldedaten vergessen und Ihr Konto zurücksetzen müssen, stellen Sie bitte sicher, dass Sie Ihre Schlüssel herunterladen.',
    'accounts_settings': 'Kontoeinstellungen',
    'accounts_settings_login_out_now': 'Jetzt abmelden',
    'accounts_settings_phone_number_disabled': 'Sie können Ihre Telefonnummer nicht ändern, da die SMS-2FA aktiviert ist.',
    'accounts_single-sign-on': 'Single Sign-on (SSO)',
    'accounts_sso_message': 'Wählen Sie einen SSO-Client aus, um sich im Portal anzumelden',
    'accounts_sso_disabled_message': 'SSO ist deaktiviert, da Ihre Organisation SAML erzwingt.',
    'accounts_sso_upgrade_message': 'Verbessern Sie die Sicherheit Ihrer Organisation, indem Sie SSO für Ihren Portalzugriff verwenden. Es ist gut!',
    'accounts_sso_upgrade_title': 'Upgrade, um SSO zu verwenden',
    'accounts_two_factor_auth': 'Zwei-Faktor-Authentifizierung',
    'accounts_two_factor_auth_app': 'APP',
    'accounts_two_factor_auth_app_code_message': 'Alternativ kopiere den untenstehenden Code und füge ihn in deine Authentifikator-App ein.',
    'accounts_two_factor_auth_app_message': 'Verwenden Sie eine App wie Google Authenticator, um Verifizierungscodes zu generieren.',
    'accounts_two_factor_auth_app_title': 'Authenticator-App',
    'accounts_two_factor_auth_app_using': 'Verwendung der App',
    'accounts_two_factor_auth_disable_app_message': 'Sind Sie sicher, dass Sie die Authentifizierungs-App-Verifizierung deaktivieren möchten?',
    'accounts_two_factor_auth_disable_sms_message': 'Sind Sie sicher, dass Sie die SMS-Verifizierung deaktivieren möchten?',
    'accounts_two_factor_auth_disable_tooltip': 'Sie können nur eine 2FA-Verifizierungsmethode verwenden. Um auf eine andere Methode umzusteigen, müssen Sie diese zuerst deaktivieren.',
    'accounts_two_factor_auth_incorrect_code': 'Der Code stimmt nicht überein. Bitte versuchen Sie es erneut.',
    'accounts_two_factor_auth_message': 'Schützen Sie Ihren Kontozugang mit der zweistufigen Verifizierung.',
    'accounts_two_factor_auth_phone_message': 'Telefonnummern dürfen nur die Ziffern 0-9 enthalten',
    'accounts_two_factor_auth_required': 'Zwei-Faktor-Authentifizierung erforderlich',
    'accounts_two_factor_auth_resend': 'Code erneut senden',
    'accounts_two_factor_auth_sms': 'SMS',
    'accounts_two_factor_auth_sms_message': 'Verwenden Sie Textnachrichten, um Verifizierungscodes zu erhalten.',
    'accounts_two_factor_auth_sms_using': 'Verwendung auf dem Handy',
    'accounts_two_factor_auth_upgrade_message': 'Verbessern Sie die Sicherheit Ihrer Organisation, indem Sie die Zwei-Faktor-Authentifizierung für Ihren Portalzugriff verwenden. Es ist gut!',
    'accounts_two_factor_auth_upgrade_title': 'Upgrade, um die Zwei-Faktor-Authentifizierung zu verwenden',
    'accounts_two_factor_auth_use_app': 'Scannen Sie den QR-Code von Ihrer Authenticator-App.',
    'accounts_two_factor_auth_use_app_code': 'Bitte geben Sie den Bestätigungscode ein, den Sie auf Ihrer Authentifizierungs-App sehen.',
    'accounts_two_factor_auth_use_sms': 'Verwenden Sie Textnachrichten (SMS), um Verifizierungscodes zu erhalten.',
    'accounts_two_factor_auth_use_sms_code': 'Geben Sie den 6-stelligen Bestätigungscode ein, den wir gesendet haben an',
    'acl_delete': 'ACL löschen',
    'acl_delete_message': 'Sind Sie sicher, dass Sie diese ACL-Regel löschen möchten?',
    'acl_details_add_disabled_hint': 'Layer 4 ACL kann nur eine einzige Regel enthalten',
    'acl_details_return_to': 'Zurück zu den ACL-Details',
    'acl_edit': 'ACL bearbeiten',
    'acl_select_layer': 'ACL-Schicht auswählen',
    'acl_select_layer_message': 'Wählen Sie die Schicht aus, für die Sie die ACL erstellen möchten.',
    'acls_backend_mode_type': 'Backend ist vom Modustyp',
    'acls_frontend_mode_type': 'Frontend ist vom Modustyp',
    'acls_header_param': 'Header/Parameter',
    'acls_no_compatible_backends': 'Es gibt keine kompatiblen Backends. ',
    'acls_no_compatible_frontends': 'Es gibt keine kompatiblen Frontends. ',
    'acls_redirect_with_code': 'Weiterleitung mit Code',
    'acls_type_layer4_warning': 'Layer-4-Frontends können nur eine einzige ACL-Regel haben.',
    'acls_type_mismatch_message': 'Frontend und Backend müssen vom gleichen Typ sein, z. B. Layer 7',
    'acls_type_warning_message': 'Dieser Assistent ist nur für Layer-7-ACLs verfügbar. Um eine ACL-Regel für ein Layer-4-Frontend zu aktualisieren, rufen Sie die ACL über die Seite „ACLs verwalten“ auf.',
    'activate_account_complete': 'Aktivierung des Kontos abschließen',
    'activate_account_error': 'Aktivierungsfehler',
    'activate_activation_passcode': 'Aktivierungs-Passcode',
    'activate_logging_in': 'Anmeldung',
    'activate_marketing_title': 'E-Mail-Adresse bestätigen',
    'activate_portal_activated': 'Ihr Loadbalancer-Portal wurde aktiviert!',
    'adc_add': 'ADC hinzufügen',
    'adc_add_address': 'ADC-Verwaltungsdetails',
    'adc_add_api_details': 'API-Konfigurationsdetails',
    'adc_add_instance': 'Eine ADC-Instanz hinzufügen',
    'adc_add_login_details': 'ADC-Anmeldedetails',
    'adc_add_message_a10': 'A10 Thunder Load Balancer ermöglichen eine effiziente und zuverlässige Anwendungsbereitstellung in jeder Umgebung. Sie liefern sichere, sichtbare und hochverfügbare Anwendungen für Geschwindigkeit und Agilität.',
    'adc_add_message_citrix': 'Citrix NetScaler vereinfacht und automatisiert die Anwendungsbereitstellung und -sicherheit in lokalen Umgebungen und in der Cloud und liefert leistungsstarke, robuste und sichere Anwendungen, unabhängig von Typ und zugrunde liegender Infrastruktur der Anwendung.',
    'adc_add_message_edgenexus': 'EdgeNexus ADCs bieten widerstandsfähige und reaktionsfähige Dienste mit granularer Kontrolle über den Anwendungsverkehr sowie sichere, zuverlässige Anwendungsbereitstellung für ständig aktive Anwendungen, die einfach bereitzustellen sind.',
    'adc_add_message_endurance': 'Loadbalancer Endurance ist ein Load Balancer der nächsten Generation, der für eine cloudnative Welt entwickelt wurde. Derzeit in der offenen Beta-Phase, wird Endurance bis Ende 2024 ein vollständiges kommerzielles Angebot werden.',
    'adc_add_message_enterprise': 'Loadbalancer Enterprise ist darauf ausgelegt, intelligent und nicht komplex zu sein, mit flexiblen Bereitstellungs- und Zahlungsoptionen. Diese voll ausgestatteten ADCs liefern die höchste Durchsatzrate und unübertroffene Zuverlässigkeit für kritische Workloads.',
    'adc_add_message_f5': 'F5 ist ein Multi-Cloud-Anwendungs- und Sicherheitsunternehmen, das sich dazu verpflichtet hat, eine bessere digitale Welt zu schaffen. Obwohl sie ihr Produktangebot diversifiziert haben, bleibt ihr BIG-IP Load Balancer ein Kernbestandteil ihres Angebots.',
    'adc_add_message_generic': 'Ein generisches Gerät ist eine Komponente in einem Netzwerksetup, das grundlegende Konnektivitäts- und Datenübertragungsfunktionen bietet. Es umfasst in der Regel Funktionen wie Routing, Switching und grundlegende Netzwerksicherheit und dient als vielseitiges Werkzeug zur Einrichtung und Verwaltung von Netzwerkverbindungen.',
    'adc_add_message_kemp': 'Progress Kemp LoadMaster ADCs sind darauf ausgelegt, eine Vielzahl von Anwendungen mit Vorlagen und Unterstützung für Webanwendungsserver einschließlich SSL und HTTP/2, Microsoft-Anwendungen und vieles mehr zu optimieren.',
    'adc_add_message_shuttle_endurance': 'Die neueste Version unserer Loadbalancing-Software',
    'adc_add_message_shuttle_enterprise': 'Leistungsstarke, stark anpassbare Lösung, die automatische Konfiguration, Inhaltsrouting und -zwischenspeicherung, DSR, Layer-7-Inhaltswechsel, VLAN-Markierung und viele andere Funktionen umfasst.',
    'adc_add_message_shuttle_stand_alone': 'Ein eigenständiger Shuttle ist ein leichter Sidecar-Proxy, der Ihr lokales oder Cloud-Netzwerk nahtlos mit unserer SaaS-Plattform verbindet. Durch die sichere Weiterleitung des Datenverkehrs über den Shuttle können Ihre ADCs ohne komplexe Konfiguration oder direkten Zugang zum öffentlichen Internet eine Verbindung zu unseren Diensten herstellen und so eine optimierte und sichere Integration gewährleisten.',
    'adc_add_message_shuttle_token': 'Tokenbasiertes Setup kommt bald.',
    'adc_add_message_shuttle_virtual_machine': 'Sie verwenden eine unserer virtuellen Maschinen, um einen Shuttle zu erstellen.',
    'adc_add_optional_info': 'Zusätzliche Informationen (optional)',
    'adc_add_ready_to_connect': 'Bereit zum Verbinden',
    'adc_add_ready_to_connect_message': 'Bitte überprüfen Sie Ihre Einstellungen. Sie können Ihre Details bearbeiten oder die Schaltfläche Senden unten drücken, wenn Sie bereit sind. Wenn die Verbindung erfolgreich ist, sehen Sie Ihr übernommenes Gerät in Ihrer ADC-Liste.',
    'adc_add_schedule': 'Zeitplan hinzufügen',
    'adc_add_shuttle_details': 'Shuttle-Details',
    'adc_backup_now': 'Jetzt sichern',
    'adc_backups_view_list': 'Backups anzeigen',
    'adc_data_no_notes': 'Keine Notizen hinzugefügt',
    'adc_data_no_tags': 'Keine Tags hinzugefügt',
    'adc_direct_access': 'Direkter Zugriff auf ADC',
    'adc_direct_access_short': 'Direkter Zugriff',
    'adc_download_success': 'Plattform erfolgreich heruntergeladen',
    'adc_duplicate_ip_message': 'Diese IP-Adresse kollidiert mit einem anderen ADC, der diese IP- und Portkombination verwendet.',
    'adc_edit': 'ADC bearbeiten',
    'adc_edit_details': 'ADC-Details bearbeiten',
    'adc_edit_lock': 'ADC sperren',
    'adc_edit_lock_message': 'Sperren Sie Ihren ADC vor Änderungen oder Entfernung.',
    'adc_empty_no_shuttle_message': 'Das Portal verwendet Shuttle (Sidecar-Agent), um Sie bei der Verwaltung Ihrer ADCs zu unterstützen. Um einen neuen ADC einzurichten, fügen Sie bitte zunächst ein Shuttle hinzu ',
    'adc_empty_shuttle_message': 'Sie haben ',
    'adc_empty_shuttle_message_2': 'Shuttles verfügbar, die Sie jetzt verwenden können, um',
    'adc_empty_shuttle_message_3': 'einen ADC hinzuzufügen',
    'adc_empty_shuttle_message_4': 'in Ihr Netzwerk.',
    'adc_empty_no_shuttle_title': 'Keine Shuttles in diesem Namensraum.',
    'adc_empty_shuttle_title': 'Bereit, Ihren ADC hinzuzufügen.',
    'adc_generic_message': 'Stellen Sie sicher, dass Sie Zugriff auf diesen generischen ADC haben.',
    'adc_go_to': 'Gehe zu ADC',
    'adc_ha_status': 'HA-Status',
    'adc_ip_out_of_range': 'Diese IP-Adresse liegt außerhalb des Bereichs des ausgewählten Shuttles.',
    'adc_locked': 'Gesperrt',
    'adc_name': 'ADC-Name',
    'adc_new_version': 'Neue Version',
    'adc_no-warp_message': 'Der Remotezugriff für dieses Gerät ist derzeit nicht verfügbar.',
    'adc_offline_message': 'Dieser ADC ist derzeit nicht online.',
    'adc_pending_adoption': 'Ausstehende Übernahme',
    'adc_pending_adoption_message': 'Dieser ADC ist mit einem Shuttle verbunden, das noch aussteht. Möchten Sie zur Shuttle-Seite verlinken?',
    'adc_port_clashes_with_another_ADC': 'Dieser Port kollidiert mit einem anderen ADC, der diese Port- und IP-Kombination verwendet.',
    'adc_remove': 'ADC entfernen',
    'adc_remove_message': 'Sind Sie sicher, dass Sie diesen ADC aus Ihrer Organisation entfernen möchten?',
    'adc_running_status': 'Laufstatus',
    'adc_security_message': 'Alles gut, hier gibt es nichts zu bewerten.',
    'adc_security_message_not_supported': 'Sicherheitsdetails für diesen Anbieter werden derzeit nicht unterstützt.',
    'adc_setup_appliance_message': 'Bitte gehen Sie zu Ihrem Download und richten Sie ihn für das Load-Balancing ein.',
    'adc_setup_connected_message': 'Herzlichen Glückwunsch! Ihr ADC-Gerät wurde eingerichtet und ist zur Übernahme bereit. Gehen Sie zur Loadbalancer-Portal-ADC-Liste und klicken Sie auf die Schaltfläche "Übernehmen".',
    'adc_setup_connected_title': 'Gerät zur Übernahme bereit',
    'adc_setup_help_prompt_message': 'Brauchen Sie Hilfe bei der Einrichtung Ihres Portals? Sprechen Sie mit einem unserer Supportmitarbeiter!',
    'adc_setup_shuttle': 'Shuttle einrichten',
    'adc_setup_skip_to_overview': 'Zur Übersicht überspringen',
    'adc_setup_successful_message': 'Shuttle erfolgreich eingerichtet',
    'adc_shuttle_add': 'Shuttle hinzufügen',
    'adc_shuttle_adoption': 'Shuttle-Einführung',
    'adc_shuttle_associate': 'Zugeordneter ADC',
    'adc_shuttle_associated': 'Zugeordnete ADCs',
    'adc_shuttle_associated_none': 'Keine zugeordneten ADCs',
    'adc_shuttle_button_message': 'Zurück zur Shuttle-Liste',
    'adc_shuttle_confirm_adc': 'ADC-Anmeldeinformationen bestätigen',
    'adc_shuttle_confirm_adc_message': 'Es sieht so aus, als ob Sie versuchen, ein Shuttle von einem Loadbalancer.org-Gerät zu übernehmen. Bitte geben Sie Ihre ADC-Anmeldeinformationen ein, damit wir es automatisch für Sie hinzufügen können.',
    'adc_shuttle_edit': 'Shuttle bearbeiten',
    'adc_shuttle_edit_lock': 'Shuttle sperren',
    'adc_shuttle_edit_lock_message': 'Sperren Sie Ihr Shuttle vor Änderungen oder Entfernung.',
    'adc_shuttle_edit_subnet_delete_message': 'Sind Sie sicher, dass Sie dieses Subnetz löschen möchten?',
    'adc_shuttle_edit_subnet_existing_gateway': 'Vorhandenes Gateway nutzen',
    'adc_shuttle_edit_subnet_new_gateway': 'Neues Gateway erstellen',
    'adc_shuttle_existing': 'Bestehendes Shuttle hinzufügen',
    'adc_shuttle_incoming_message': 'Diese Shuttle(s) wurden in den letzten Sekunden hinzugefügt.',
    'adc_shuttle_incoming_message_2': 'HINWEIS: Dies sind möglicherweise nicht die Shuttles, die Sie suchen!',
    'adc_shuttle_incoming_message_3': 'Ihr Shuttle ist nicht aufgeführt.',
    'adc_shuttle_intercom_message': 'Ich habe die Schritte auf der Seite „Shuttle hinzufügen“ abgeschlossen, kann meinen Shuttle jedoch nicht sehen.',
    'adc_shuttle_management': 'Shuttle-Verwaltung',
    'adc_shuttle_name': 'Shuttle-Name',
    'adc_shuttle_new': 'Neues Shuttle hinzufügen',
    'adc_shuttle_new_message': 'Ein Shuttle ist ein Sidecar-Agent, der eine Kommunikationsverbindung zwischen dem Portal und den ADCs in Ihrem Netzwerk herstellt.',
    'adc_shuttle_new_message_2': 'Um einen ADC im Portal hinzuzufügen und zu verwalten, müssen Sie zuerst ein Shuttle hinzufügen.',
    'adc_shuttle_new_title': 'Was ist ein Shuttle?',
    'adc_shuttle_no_associated_adcs': 'Es gibt keine ADCs, die mit diesem Shuttle verbunden sind.',
    'adc_shuttle_remove': 'Shuttle entfernen',
    'adc_shuttle_remove_message': 'Sind Sie sicher, dass Sie dieses Shuttle aus Ihrer Organisation entfernen möchten?',
    'adc_shuttle_skip-adoption': 'ADC-Übernahme überspringen',
    'adc_shuttle_token_linux': 'Linux-Umgebung',
    'adc_shuttle_token_linux_message': 'Das Shuttle-Shell-Skript funktioniert unter Linux. Kopieren Sie einfach das Token in Ihr Terminal und führen Sie es aus. Es werden automatisch alle erforderlichen Ressourcen installiert.',
    'adc_shuttle_token_message': 'Kopieren Sie das folgende Token und führen Sie es in der Shell-Umgebung Ihres Loadbalancers aus:',
    'adc_shuttle_token_message_standalone': 'Kopieren Sie das folgende Token und führen Sie es in Ihrer Shell-Umgebung aus:',
    'adc_shuttle_token_requirements': 'Anforderungen',
    'adc_shuttle_token_requirements_message': 'Bitte stellen Sie sicher, dass Folgendes in Ihrer Umgebung installiert ist:',
    'adc_shuttle_update': 'Shuttle aktualisieren',
    'adc_shuttle_waiting': 'Warten auf Shuttle',
    'adc_this_cant_message': 'Diese Aktion kann derzeit nicht komplett durchgeführt werden oder Sie haben keine Berechtigung',
    'adc_update_disabled': 'Dieser ADC unterstützt keine Updates über das Portal.',
    'adc_update_error': 'Fehler beim Aktualisieren dieses ADCs. Bitte kontaktieren Sie den Support oder versuchen Sie es in ein paar Minuten erneut.',
    'adc_update_now': 'Jetzt aktualisieren',
    'adc_view_schedules': 'Zeitpläne anzeigen',
    'adc_view_security_risks': 'Sicherheitsrisiken anzeigen',
    'adc_waiting_for_shuttle': 'Warten auf Shuttle-Einrichtung...',
    'adc_warp_to_adc': 'Zu ADC springen',
    'adc_warp_vendor_not_included': 'Warp ist für diesen Anbieter derzeit nicht verfügbar',
    'adc_widget_connections': 'Verwendete ADC-Verbindungen',
    'admin_panel': 'Portaladministrator',
    'advanced_services': 'Erweiterte Dienste',
    'advanced_services_advanced_stats': 'Erweiterte Statistiken',
    'advanced_services_buffer_size': 'Puffergröße',
    'advanced_services_client_timeout': 'Client-Timeout',
    'advanced_services_conn_timeout': 'Verbindungszeitüberschreitung',
    'advanced_services_email_alert_from': 'E-Mail-Benachrichtigung von',
    'advanced_services_email_alert_to': 'E-Mail-Benachrichtigung an',
    'advanced_services_email_alerts': 'E-Mail-Benachrichtigungen',
    'advanced_services_email_server_addr': 'E-Mail-Serveradresse',
    'advanced_services_email_server_port': 'E-Mail-Serverport',
    'advanced_services_enable_multi_thread': 'Mehrere Threads aktivieren',
    'advanced_services_enable_ssl': 'SSL aktivieren',
    'advanced_services_enable_stats': 'Statistikseite aktivieren',
    'advanced_services_haproxy_stats_advanced': 'HaproxyStatsAdvanced',
    'advanced_services_hdr_buf_len': 'Header-Pufferlänge',
    'advanced_services_logging': 'Protokollierung',
    'advanced_services_multi_thread': 'Mehrere Threads',
    'advanced_services_no_of_threads': 'Anzahl der Threads',
    'advanced_services_persist_repl_port': 'Port für Persistenzreplikation',
    'advanced_services_persist_replication': 'Persistenzreplikation aktivieren',
    'advanced_services_persistence_table': 'Persistenztabellenreplikation',
    'advanced_services_real_server_timeout': 'Timeout für echte Serverantwort',
    'advanced_services_req_buf_len': 'Anforderungspufferlänge',
    'advanced_services_ssl_cache_options': 'SSL-Cache-Optionen',
    'advanced_services_ssl_cache_size': 'SSL-Cache-Größe',
    'advanced_services_statistics_page': 'Statistikseite',
    'app_overlay_message': 'funktioniert am besten auf einem größeren Bildschirm',
    'auditing': 'Prüfung',
    'auditing_activity_type': 'Aktivitätstyp',
    'auditing_session_log': 'Sitzungsprotokoll',
    'auditing_session_time': 'Sitzungszeit',
    'auditing_upgrade_message': 'Verbessern Sie die Sicherheit Ihrer Organisation, indem Sie die Überwachung für den Zugriff auf Ihr Portal verwenden. Es ist gut!',
    'auditing_upgrade_title': 'Upgrade zur Verwendung der Überwachung',
    'backup_download_message': 'Bitte geben Sie Ihr Passwort ein, um dieses Backup zu entschlüsseln.',
    'backup_for': 'Backup für',
    'backup_restore': 'Backup & Wiederherstellung',
    'backup_restore_auto_backup': 'Automatisches Backup',
    'backup_restore_download_complete': 'Backup-Download abgeschlossen',
    'backup_restore_make_fip_active': 'Aktiv machen',
    'backup_restore_node_name': 'Knotenname',
    'backup_restore_restore_from': 'Wiederherstellen aus Backup',
    'backup_restore_restore_model_text': 'Das Gerät wird wiederhergestellt. Sie werden abgemeldet und neu geladen in',
    'backup_restore_select_node_message': 'Bitte wählen Sie aus, um von einem Knoten oder einer Teilwiederherstellung wiederherzustellen.',
    'backup_restore_select_section_message': 'Sie können einzelne Elemente zum Wiederherstellen auswählen von',
    'backup_restore_select_type': 'Wiederherstellungstyp wählen',
    'backup_restore_upload_backup': 'Backup hochladen',
    'backup_restore_uploaded_backups': 'Hochgeladene Backups',
    'backup_widget_backups_used': 'backups verwendet',
    'billing_adc_pack': 'Zusätzliche',
    'billing_portal': 'Ebenen',
    'billing_add_payment_method': 'Neue Zahlungsmethode hinzufügen',
    'billing_address': 'Rechnungsadresse',
    'billing_amount': 'Betrag',
    'billing_bad_debt': 'Uneinbringliche Schulden',
    'billing_cancel_plan': 'Plan kündigen',
    'billing_card_cvc': 'CVC',
    'billing_card_details': 'Kartendetails',
    'billing_card_ending': 'kartenende...',
    'billing_card_name': 'Name auf Karte',
    'billing_card_number': 'Kartennummer',
    'billing_card_selected': 'Ausgewählte Karte',
    'billing_contact': 'Kontakt Abrechnung',
    'billing_date': 'Abrechnungsdatum',
    'billing_draft': 'Entwurf',
    'billing_edit_payment_method': 'Zahlungsmethode bearbeiten',
    'billing_email_address': 'Rechnungs-E-Mail-Adresse',
    'billing_edit_subscription': 'Abonnement bearbeiten',
    'billing_expiry': 'Ablaufdatum',
    'billing_invoice': 'Rechnung',
    'billing_invoice_history': 'Rechnungsverlauf',
    'billing_item': 'Artikel',
    'billing_items': 'Abrechnungsartikel',
    'billing_make_default': 'Als Standard festlegen',
    'billing_monthly_cost': 'Monatliche Kosten',
    'billing_name': 'Rechnungsname',
    'billing_paid': 'Bezahlt',
    'billing_payment_method': 'Zahlungsmethode',
    'billing_payment_methods': 'Zahlungsmethoden',
    'billing_payment_status': 'Status der Zahlungsübermittlung',
    'billing_remove_payment': 'Zahlungsmethode entfernen',
    'billing_remove_payment_message': 'Sind Sie sicher, dass Sie diese Zahlungsmethode entfernen möchten?',
    'billing_remove_subscription': 'Abo kündigen',
    'billing_remove_subscription_hint': 'Abonnement bereits gekündigt',
    'billing_remove_subscription_message': 'Möchten Sie dieses Abonnement wirklich kündigen?',
    'billing_waiting_payment': 'Warten auf Zahlung',
    'certificate_add_ca': 'CA hinzufügen',
    'certificate_add_certificate': 'Zertifikat hinzufügen',
    'certificate_add_crl': 'CRL hinzufügen',
    'certificate_apply_csr': 'CSR anwenden',
    'certificate_common_name': 'Allgemeiner Name',
    'certificate_country': 'Land',
    'certificate_country_code': 'Ländercode',
    'certificate_create_cert': 'Zertifikat erstellen',
    'certificate_create_csr': 'CSR erstellen',
    'certificate_create_self-signed': 'Selbstsigniert erstellen',
    'certificate_csr': 'Zertifikatsanfrage',
    'certificate_csrs_subject_alt': 'Alternativer Name(s) des Subjekts',
    'certificate_counter_label_total': 'Gesamtzahl der Zertifikate',
    'certificate_counter_label_expiring': 'Läuft ab (30 Tage)',
    'certificate_counter_label_expired': 'Abgelaufene Zertifikate',
    'certificate_counter_none': 'Keine Zertifikate verfügbar.',
    'certificate_counter_none_message': 'Alle mit Ihren ADCs verknüpften Sicherheitszertifikate werden hier angezeigt.',
    'certificate_details': 'Details zum Zertifikat',
    'certificate_domain_cn': 'Domain (CN)',
    'certificate_edit_ca': 'CA bearbeiten',
    'certificate_edit_cert': 'Zertifikat bearbeiten',
    'certificate_edit_certificate': 'Zertifikat bearbeiten',
    'certificate_edit_crl': 'CRL bearbeiten',
    'certificate_edit_csr': 'CSR bearbeiten',
    'certificate_expired_today': 'Heute abgelaufen',
    'certificate_expired_x_days_ago': 'Abgelaufen vor {{placeholder}} Tagen',
    'certificate_expires_x_days': 'Läuft in {{placeholder}} Tagen ab',
    'certificate_input_subject_alt': 'subjectAlt',
    'certificate_inter_certs': 'Zwischenzertifikat',
    'certificate_invalid_email': 'Ungültige E-Mail',
    'certificate_issuer': 'Emittent',
    'certificate_key_length': 'Schlüssellänge des CSR',
    'certificate_locality': 'Ort (L)',
    'certificate_name': 'Zertifikatsname',
    'certificate_organization': 'Organisation (O)',
    'certificate_organizational_unit': 'Organisationseinheit (OU)',
    'certificate_private_key': 'Privater Schlüssel',
    'certificate_root_cert': 'Root-Zertifikat',
    'certificate_san_label': 'Alternativer/e Betreffname/n (SAN)',
    'certificate_select_cert': 'Zertifikat auswählen',
    'certificate_self_signed': 'Selbstsigniert',
    'certificate_signature_algorithm': 'Signaturalgorithmus',
    'certificate_state_st': 'Bundesland oder Provinz (ST)',
    'certificate_subject_alt': 'Alternativer Name des Subjekts (SAN)',
    'certificate_view_csr': 'CSR anzeigen',
    'checkout_cart': 'Warenkorb',
    'checkout_cart_add_hint_test': 'Sie können nicht mehr als eine Abonnementstufe haben',
    'checkout_cart_empty_message': 'Ihr Warenkorb ist leer',
    'checkout_cart_max-items_message': 'Sie haben die maximale Anzahl an Artikeln im Warenkorb erreicht.',
    'checkout_interval_hint_test': 'Sie können die Abonnementarten nicht mischen',
    'checkout_select_payment_card': 'Zahlungsart auswählen',
    'checkout_select_product': 'Produkt auswählen',
    'checkout_selected_payment_card': 'Ausgewählte Zahlungsmethode',
    'checkout_selected_product': 'Ausgewähltes Produkt',
    'cipher_list_available': 'Verfügbare Verschlüsselungen',
    'cipher_list_create_new': 'Neue Verschlüsselung hinzufügen',
    'cipher_list_delete_cipher': 'Verschlüsselung löschen',
    'cipher_list_edit_cipher': 'Verschlüsselung bearbeiten',
    'cipher_list_name': 'Listenname',
    'cipher_list_new': 'Neue Verschlüsselungsliste',
    'cipher_list_selected': 'Ausgewählte Verschlüsselungen',
    'cipher_list_title': 'SSL-Verschlüsselungslisten',
    'cipher_list_tls_version': 'TLS-Version',
    'cipher_list_view': 'Verschlüsselungsliste anzeigen',
    'confirm_logout': 'Sind Sie sicher, dass Sie sich abmelden möchten?',
    'create_bond_available_interfaces': 'Verfügbare Schnittstellen',
    'create_bond_bond_name': 'Bond-Name',
    'create_bond_eth_brackets': '(eth)',
    'create_bond_help_text': 'Klicken Sie auf zwei oder mehr Schnittstellen, um sie zu verbinden',
    'create_bond_no_interfaces_found': 'Keine Schnittstellen gefunden.',
    'create_bond_please_return_to': 'Bitte zurückkehren zu',
    'csv_importer_title': 'Ergebnisse anzeigen',
    'csv_importer_description': 'In diesem Modal müssen Sie die CSV-Überschriften den entsprechenden Übermittlungsfeldern zuordnen. Alle Pflichtfelder müssen übereinstimmen, bevor Sie die Übermittlung durchführen können. Nach erfolgreicher Übermittlung erhält jeder Benutzer eine E-Mail mit einem Aktivierungslink. Anschließend wird er aufgefordert, seinen Namen einzugeben und ein Passwort zu erstellen. Nach der Passwortfestlegung müssen Benutzer eine Kopie ihres privaten Benutzerschlüssels herunterladen und für den Fall einer Kontowiederherstellung an einem sicheren Ort aufbewahren.',
    'csv_importer_missing_fields': 'Fehlende Pflichtfelder:',
    'csv_importer_missing_fields_set': 'Anzahl der erforderlichen Felder:',
    'csv_importer_heading_csv_headings': 'CSV-Überschriften',
    'csv_importer_heading_submission_headings': 'Einreichungseigenschaften',
    'csv_importer_number_records': 'Anzahl Datensätze:',
    'csv_importer_preview': 'Vorschau',
    'csv_importer_import_users': 'Benutzer importieren',
    'csv_importer_switch_view_errors': 'Fehler anzeigen',
    'csv_importer_switch_view_results': 'Ergebnisse anzeigen',
    'dashboard_advert_boost_title': 'Verbessern Sie Ihr ADC-Erlebnis mit neuen Funktionen',
    'dashboard_advert_demo_title': 'Brauchen Sie Hilfe? Vereinbaren Sie eine kostenlose Demo mit einem Portal-Ingenieur',
    'dashboard_advert_trial_title': 'Probieren Sie unseren voll ausgestatteten Lastenausgleicher 30 Tage lang kostenlos aus',
    'dashboard_features': 'Funktionen',
    'dashboard_guides': 'Anleitungen',
    'dashboard_quick_links': 'Schnellzugriffe',
    'dashboard_whats_new': 'Portal: Was ist neu',
    'date_time_current_sys_time': 'Aktuelle Systemzeit',
    'date_time_date_out_of_range_license_text': 'Warnung: Ihr Datum liegt außerhalb Ihres aktuellen Lizenzzeitraums. Durch Ändern Ihres Datums wird Ihre Lizenz ungültig. Sind Sie sicher, dass Sie fortfahren möchten?',
    'date_time_date_out_of_range_license_title': 'Lizenzwarnung',
    'date_time_date_out_of_range_relogin_text': 'Warnung: Ihr Datum und Ihre Uhrzeit sind auf eine Zeit in der Zukunft eingestellt. Möglicherweise werden Sie aufgefordert, sich erneut anzumelden.',
    'date_time_date_out_of_range_relogin_title': 'Datumswarnung',
    'date_time_ntp_server_1': 'NTP-Server 1',
    'date_time_ntp_server_2': 'NTP-Server 2',
    'date_time_ntp_server_3': 'NTP-Server 3',
    'date_time_ntp_servers': 'NTP-Server',
    'date_time_set_date_time': 'Datum & Uhrzeit festlegen',
    'date_time_set_manually': 'Datum und Uhrzeit manuell festlegen',
    'date_time_set_ntp': 'NTP festlegen',
    'date_time_set_timezone': 'Zeitzone festlegen',
    'date_time_sys_timezone': 'Systemzeitzone',
    'date_time_use_ntp_servers': 'NTP-Server verwenden',
    'error_page_title': 'Diese Seite ist derzeit nicht verfügbar',
    'error_page_message': 'Wir arbeiten an einer Lösung für Sie.',
    'execute_command_common': 'Gemeinsame Befehle',
    'execute_command_input': 'Befehlseingabe',
    'execute_shell_command': 'Shell-Befehl ausführen',
    'external_all_rights_reserved': 'Alle Rechte vorbehalten',
    'external_link': 'Externer Link',
    'fallback_add': 'Fallback-Server hinzufügen',
    'fallback_masq': 'MASQ-Backup',
    'fallback_page_edit': 'Fallback-Seite bearbeiten',
    'fallback_pages': 'Fallback-Seiten',
    'fallback_pages_add_page': 'Fallback-Seite hinzufügen',
    'fallback_pages_delete_page': 'Seite löschen',
    'fallback_pages_delete_page_message': 'Sind Sie sicher, dass Sie die Fallback-Seiten löschen möchten?',
    'fallback_pages_page_content': 'Seiteninhalt',
    'fallback_pages_usage': 'Verwendung der Fallback-Seite',
    'fallback_server': 'Fallback-Server or Ersatzserver',
    'floating_ip': 'Floating-IP',
    'floating_ip_add': 'Floating-IP hinzufügen',
    'floating_ip_all_disable': 'Alle Floating-IPs deaktivieren',
    'floating_ip_all_enable': 'Alle Floating-IPs aktivieren',
    'floating_ip_change': 'IP geändert',
    'floating_ip_change_message': 'Die IP, die Sie ändern, ist einem Dienst zugeordnet, und dieser Dienst muss neu geladen werden',
    'floating_ip_delete_message': 'Alle ausgewählten, nicht verwendeten Floating-IPs wurden gelöscht.',
    'floating_ip_delete_multiple_ips': 'Mehrere IPs löschen',
    'floating_ip_delete_selected': 'Ausgewählte Floating-IPs löschen',
    'floating_ip_deleting_multiple_ip': 'IP löschen',
    'floating_ip_disable': 'Floating-IP deaktivieren',
    'floating_ip_disable_selected': 'Ausgewählte Floating-IPs deaktivieren',
    'floating_ip_edit': 'Floating-IP bearbeiten',
    'floating_ip_enable': 'Floating-IP aktivieren',
    'floating_ip_enable_selected': 'Ausgewählte Floating-IPs aktivieren',
    'floating_ip_in_use': 'In Verwendung',
    'floating_ip_usage': 'Verwendung der Floating-IP',
    'floating_ip_usage_for_ip': 'Verwendung für IP',
    'free_trial_step_1_button': 'Loslegen',
    'free_trial_step_1_intro': 'Ihr Test ist eine vollständig uneingeschränkte Version unserer Enterprise VA Max und kann 30 Tage lang kostenlos verwendet werden. Sollten Sie eine Verlängerung des Tests benötigen, kontaktieren Sie uns bitte.',
    'free_trial_step_1_simple_steps': 'Einfache Schritte:',
    'free_trial_step_1_step_message_1': 'Wählen Sie Ihren Hypervisor und laden Sie ihn herunter.',
    'free_trial_step_1_step_message_2': 'Wenn Sie während Ihres kostenlosen ADC-Tests Hilfe benötigen, haben Sie vollen Zugriff auf unseren 24/7-Support',
    'free_trial_step_1_step_message_3': 'Registrieren Sie sich für den ADC-Portal-Test - unser neues zentrales Managementsystem',
    'free_trial_step_1_title': 'Lassen Sie uns Ihren Enterprise-ADC-Test kostenlos starten.',
    'free_trial_step_2_intro': 'Wählen Sie Ihren bevorzugten Hypervisor aus der Liste unten. Unser Lastenausgleicher kann auf einer Reihe anderer Hypervisoren ausgeführt werden. Wenn Ihrer nicht in der Liste enthalten ist, kontaktieren Sie uns, und wir helfen Ihnen weiter.',
    'free_trial_step_2_min_spec': '64-Bit-CPU, Virtual-Technology-Hardwareunterstützung (entweder Intel-VT-x oder AMD-V-kompatible CPUs). Standardmäßig werden der virtuellen Appliance 2 vCPUs, 4 GB RAM und eine 20-GB-Virtualfestplatte zugewiesen, was für Anwendungen mit geringer bis mittlerer Durchsatzleistung geeignet sein sollte. (Sie können bei Bedarf erhöht werden)',
    'free_trial_step_2_title': 'Wählen Sie Ihren Hypervisor aus.',
    'free_trial_step_3_button': 'Portal ansehen',
    'free_trial_step_3_intro': 'Vielen Dank für das Herunterladen Ihres kostenlosen Enterprise-ADC-Tests. Sie sind nun bereit, die Appliance auf Ihrer virtuellen Maschine einzurichten.',
    'free_trial_step_3_intro_2': 'Das Schnellstart-Handbuch (im Download enthalten) führt Sie durch die Einrichtungsschritte. Wenn Sie weitere Unterstützung benötigen, kontaktieren Sie uns bitte.',
    'free_trial_step_3_intro_3': 'Andere Benutzer finden es vorteilhaft, unser neues ADC-Portal zu nutzen - wir haben bereits ein Konto für Sie erstellt, aktivieren Sie es einfach, um es kostenlos zu erkunden.',
    'free_trial_step_3_quick_start': 'Schnellstartanleitung',
    'free_trial_step_3_title': 'Vielen Dank.',
    'free_trial_step_3_title_2': 'Probieren Sie das neue Loadbalancer ADC Portal',
    'free_trial_step_4_button_action_later': 'Ich mache das später',
    'free_trial_step_4_button_activate_trial': 'Aktivieren Sie meinen kostenlosen Portal-Test',
    'free_trial_step_4_intro': 'Das Loadbalancer ADC Portal ist eine intuitive, aber umfassende Plattform, die Automatisierung, Orchestrierung, Management und Analytik für die Anwendungsbereitstellung in On-Premise-, Cloud-, Hybrid- und Multi-Cloud-Umgebungen ermöglicht.',
    'free_trial_step_4_step_message_1': 'Konsolidieren Sie alle Ihre Geräte in einem einzigen Dashboard.',
    'free_trial_step_4_step_message_2': 'Erstellen Sie automatisierte Workflows, um häufige ADC-Aufgaben zu ermöglichen.',
    'free_trial_step_4_step_message_3': 'Volle End-to-End-Sicherheit unter Verwendung modernster kryptografischer Technologie.',
    'free_trial_step_4_title': 'Loadbalancer ADC Portal',
    'free_trial_step_5_button_schedule_demo': 'Demo planen',
    'free_trial_step_5_button_skip': 'Überspringen & beenden',
    'free_trial_step_5_intro': 'Benötigen Sie Hilfe bei der Einrichtung Ihres ADC-Geräts? Warum planen Sie nicht eine Demo oder einen Support-Anruf mit einem unserer Ingenieure. Sie können ein Treffen zu einem Datum und einer Uhrzeit vereinbaren, die Ihnen passt, indem Sie auf die Schaltfläche unten klicken.',
    'free_trial_step_5_intro_2': 'Alternativ ist rund um die Uhr Unterstützung für die Dauer Ihres kostenlosen Tests inbegriffen, und unser Team kann per E-Mail ',
    'free_trial_step_5_intro_3': 'über den Online-Chat oder durch Ausfüllen eines Support-Tickets erreicht werden - ',
    'free_trial_step_5_title': 'Brauchen Sie Hilfe? Warum nicht eine Demo planen?',
    'gslb_add_global_name': 'Globalen Namen hinzufügen',
    'gslb_add_global_names': 'Globale Namen hinzufügen',
    'gslb_add_member': 'Mitglied hinzufügen',
    'gslb_add_pool': 'Pool hinzufügen',
    'gslb_add_topology': 'Topologie hinzufügen',
    'gslb_available_members': 'Verfügbare Mitglieder',
    'gslb_delete_global_name': 'Globalen Namen löschen',
    'gslb_delete_member': 'Mitglied löschen',
    'gslb_delete_pool': 'Pool löschen',
    'gslb_delete_topology': 'Topologie löschen',
    'gslb_edit_global_name': 'Globalen Namen bearbeiten',
    'gslb_edit_member': 'Mitglied bearbeiten',
    'gslb_edit_pool': 'Pool bearbeiten',
    'gslb_edit_topology': 'Topologie bearbeiten',
    'gslb_global_name': 'Globaler Name',
    'gslb_global_names': 'Globale Namen',
    'gslb_global_services': 'Weltweiter Service',
    'gslb_healthcheck_expected_codes': 'Erwartete Codes überwachen',
    'gslb_healthcheck_hostname': 'Hostname überwachen',
    'gslb_healthcheck_interval': 'Überwachungsintervall',
    'gslb_healthcheck_ip': 'IP überwachen',
    'gslb_healthcheck_match_re': 'Übereinstimmungs-RE überwachen',
    'gslb_healthcheck_mode': 'Überwachungsmodus',
    'gslb_healthcheck_no_scripts_found': 'Keine Health-Check-Skripte gefunden',
    'gslb_healthcheck_port': 'Port überwachen',
    'gslb_healthcheck_retries': 'Überwachungsversuche',
    'gslb_healthcheck_script': 'Überwachungsskript',
    'gslb_healthcheck_send_string': 'Sendestring überwachen',
    'gslb_healthcheck_status': 'Überwachungsstatus',
    'gslb_healthcheck_timeout': 'Überwachungs-Timeout',
    'gslb_healthcheck_type': 'Überwachungstyp',
    'gslb_healthcheck_url_path': 'URL-Pfad überwachen',
    'gslb_healthcheck_use_ssl': 'SSL verwenden überwachen',
    'gslb_ip_subnet': 'IP-Subnetz',
    'gslb_lb_method': 'LB-Methode',
    'gslb_max_address_returned': 'Maximale Adresse zurückgegeben',
    'gslb_no_available_global_names': 'Keine verfügbaren globalen Namen',
    'gslb_no_data_gslb_pools': 'Derzeit werden keine Daten für GSLB-Pools gesammelt.',
    'gslb_no_members': 'Keine Mitglieder',
    'gslb_no_members_text': 'Sie haben keine Mitglieder eingerichtet. Mitglieder sind erforderlich, um eine Topologie zu erstellen.',
    'gslb_pools_input_monitorCode': 'Überwachungscode',
    'gslb_refuse_on_failure': 'Bei Misserfolg ablehnen',
    'gslb_report_distribution': 'GSLB-Verteilungsstatusbericht',
    'gslb_report_distribution_error': 'Daten zum GSLB-Verteilungsstatus sind nicht verfügbar',
    'gslb_report_health_check': 'GSLB-Health-Check-Bericht',
    'gslb_report_health_check_error': 'Daten zum GSLB-Health-Check sind nicht verfügbar',
    'gslb_return_to_gslb_page': 'Zurück zur GSLB-Seite',
    'gslb_selected_members': 'Ausgewählte Mitglieder',
    'gslb_time_to_live': 'Lebensdauer',
    'ha_conf': 'Konfiguration für hohe Verfügbarkeit',
    'ha_conf_add_node': 'Knoten hinzufügen',
    'ha_conf_administrator_email': 'E-Mail des Administrators*',
    'ha_conf_administrator_password': 'Administratorpasswort*',
    'ha_conf_bind_address': 'Bind-Adresse',
    'ha_conf_confirm_service_restart': 'Neustart des Dienstes bestätigen',
    'ha_conf_confirm_service_restart_message': 'Sie starten einen Dienst auf einem anderen Knoten neu als den, auf dem Sie derzeit angemeldet sind.',
    'ha_conf_join': 'Beitritt zur hohen Verfügbarkeit',
    'ha_conf_join_confirmation': 'Bestätigung für den Beitritt zur hohen Verfügbarkeit',
    'ha_conf_join_confirmation_message': 'Bitte bestätigen Sie, dass Sie den Vorgang zum Hinzufügen des Knotens fortsetzen möchten, da dies die Konfiguration Ihrer Peers löscht.',
    'ha_conf_last_health_check': 'Letzter Gesundheitscheck',
    'ha_conf_latency': 'Latenz',
    'ha_conf_peer_ip_address': 'IP-Adresse des Peers*',
    'ha_conf_peer_port': 'Peer-Port*',
    'ha_conf_promote': 'Fördern',
    'ha_conf_re_sync_config': 'Konfiguration neu synchronisieren',
    'ha_conf_reload_restart_services': 'Dienste neu laden/neu starten',
    'ha_conf_remove_node_title': 'Knoten entfernen',
    'ha_conf_remove_node_message': 'Sind Sie sicher, dass Sie diesen Knoten löschen möchten?',
    'ha_conf_restore_confirmation': 'Bestätigung der Knotenwiederherstellung',
    'ha_conf_restore_confirmation_message': 'Bitte bestätigen Sie, dass Sie den Knoten wiederherstellen möchten.',
    'ha_conf_restore_node': 'Knoten wiederherstellen',
    'ha_conf_services_message': 'Einige Dienste müssen neu gestartet werden, bevor Sie einen Knoten hinzufügen können. Stellen Sie sicher, dass der andere Knoten auf dem neuesten Stand ist und die erforderlichen Dienste ausgeführt werden.',
    'ha_conf_services_unavailable': 'Dienste nicht verfügbar',
    'hanging_acl_delete': 'ACL löschen',
    'hanging_acl_deleted_all': 'Alle hängenden ACLs gelöscht',
    'hanging_acl_deleting': 'Lösche hängende ACL',
    'hanging_acls': 'Hängende ACLs',
    'hanging_acls_acls_list': 'Nachfolgend finden Sie eine Liste von ACLs, die keinem Frontend zugeordnet sind.',
    'hanging_acls_deleted_all': 'Alle hängenden ACLs gelöscht',
    'hanging_acls_deleting': 'Lösche hängende ACLs',
    'hanging_backend_delete': 'Backend löschen',
    'hanging_backend_delete_message': 'Sind Sie sicher, dass Sie das Backend löschen möchten?',
    'hanging_backend_delete_message_multiple': 'Sind Sie sicher, dass Sie die ausgewählten hängenden Backends löschen möchten?',
    'hanging_backend_delete_selected': 'Ausgewählte hängende Backends löschen',
    'hanging_backend_deleted_all': 'Alle hängenden Backends gelöscht',
    'hanging_backend_deleting': 'Lösche hängendes Backend',
    'hanging_backend_real_servers_usage': 'Nutzung echter Server',
    'hanging_backends': 'Hängende Backends',
    'hanging_backends_backends_info': 'Sie können Regeln erstellen, um sie zuzuweisen oder sie zu löschen',
    'hanging_backends_backends_list': 'Nachfolgend finden Sie eine Liste von Backends, die keinem Frontend zugeordnet sind.',
    'hanging_backends_create_acl': 'ACL erstellen',
    'hanging_backends_deleting': 'Lösche hängende Backends',
    'hanging_backends_usage_for_backend': 'Nutzung echter Server für hängendes Backend',
    'hanging_backends_usage_real_server_address': 'Adresse echter Server',
    'hanging_backends_usage_real_server_label': 'Label echter Server',
    'hanging_groups_assign': 'Hängende Gruppen zuweisen',
    'hanging_groups_remote_node': 'Diese Zuweisung erfolgt auf einem entfernten Knoten',
    'hanging_real_assign': 'Weisen Sie echte Server zu',
    'hanging_real_assign_backend': 'Einem Backend zuweisen',
    'hanging_real_assign_backend_count': 'Verfügbare Backends',
    'hanging_real_assign_confirm_message_multiple': 'Möchten Sie die ausgewählten realen Server wirklich den ausgewählten Backends zuweisen?',
    'hanging_real_assign_confirm_message_single': 'Sind Sie sicher, dass Sie einen echten Server zuweisen möchten',
    'hanging_real_assign_no_backend_message': 'Keine passenden Backends',
    'hanging_real_assigned_all': 'Alle ausgewählten hängenden realen Server zugewiesen',
    'hanging_real_delete': 'Realen Server löschen',
    'hanging_real_delete_all': 'Löschen Sie alle hängenden realen Server',
    'hanging_real_delete_confirm_message_multiple': 'Möchten Sie die ausgewählten hängenden realen Server wirklich löschen?',
    'hanging_real_delete_confirm_message_single': 'Möchten Sie den realen Server wirklich löschen ',
    'hanging_real_deleting': 'Hängenden realen Server löschen',
    'hanging_reals': 'Hängende echte Server',
    'hanging_reals_deleted_all': 'Alle hängenden realen Server gelöscht',
    'hanging_reals_deleting': 'Löschen hängender realer Server',
    'hanging_reals_real_servers_usage': 'Echte Servernutzung',
    'hanging_reals_reals_list': 'Unten finden Sie eine Liste realer Server, die keinem Dienst zugeordnet sind.',
    'hanging_reals_usage_real_server_address': 'Echte Serveradresse',
    'hanging_reals_usage_real_server_label': 'Etikett für echte Server',
    'header_add_header': 'Header hinzufügen',
    'header_edit_header': 'Header bearbeiten',
    'header_replace_value': 'Wert ersetzen',
    'health_check': 'Gesundheitsüberprüfung',
    'health_check_add': 'Gesundheitsüberprüfung hinzufügen',
    'health_check_confirm_delete_text': 'Sind Sie sicher, dass Sie diese Gesundheitsüberprüfung löschen möchten?',
    'health_check_created_by': 'Erstellt von',
    'health_check_script_content': 'Skriptinhalt',
    'health_checks': 'Gesundheitsüberprüfungen',
    'health_checks_radius_secret': 'Radiusgeheimnis',
    'health_checks_usage': 'Nutzung der Gesundheitsüberprüfung',
    'host_dns': 'Hostname & DNS',
    'host_dns_domain_name_servers': 'Domänennamenserver',
    'ip_add_group': 'IP-Gruppe hinzufügen',
    'ip_delete_group_text': 'Möchten Sie diese Gruppe wirklich löschen?',
    'ip_edit_group': 'IP-Gruppe bearbeiten',
    'ip_enable_fip': 'Floating-IP aktivieren',
    'ip_enable_ipv4': 'IPv4 aktivieren',
    'ip_enable_ipv6': 'IPv6 aktivieren',
    'ip_go_to_groups': 'Zu den Gruppen für Floating-IPs gehen',
    'ip_group_no_mask_set': 'Keine Maske festgelegt',
    'ip_groups': 'IP-Gruppen',
    'ip_groups_disconnection_warning': ' Bitte stellen Sie sicher, dass dies korrekt ist, da Sie sonst die Verbindung zu Ihrem Loadbalancer verlieren.',
    'ip_groups_gateway_changed': 'Änderung des Standard-Gateways.',
    'ip_groups_gateway_changed_text': 'Das Standard-Gateway wurde auf die neue IP-Gruppe geändert ',
    // TODO: Remove when IP groups is renamed globally.
    'ip_groups_subnets': 'IP-Gruppen (Subnetze)',
    // TODO: END
    'ip_groups_unassigned_group': 'Nicht zugewiesene Gruppe',
    'ip_groups_usage': 'Nutzung der IP-Gruppen',
    'ip_hanging_groups': 'Hängende Gruppen',
    'ip_ipv4_mask': 'IPv4-Maske',
    'ip_ipv4_mask_upper': 'IPv4-Maske',
    'ip_ipv4_network': 'IPv4-Netzwerk',
    'ip_ipv4_network_upper': 'IPv4-Netzwerk',
    'ip_ipv6_mask': 'IPv6-Maske',
    'ip_ipv6_mask_upper': 'IPv6-Maske',
    'ip_ipv6_network': 'IPv6-Netzwerk',
    'ip_ipv6_network_upper': 'IPv6-Netzwerk',
    'ip_name_change': 'Gruppenname geändert',
    'ip_name_change_text': 'Der Gruppenname wurde geändert. Dadurch werden alle IPs in dieser Gruppe deaktiviert und dann wieder aktiviert. Möchten Sie fortfahren?',
    'ip_no_ip_config': 'Derzeit sind keine IP-Gruppen konfiguriert. Um eine neue Floating-IP zu erstellen, erstellen Sie bitte zuerst eine neue IP-Gruppe, bevor Sie es erneut versuchen.',
    'ip_no_network_set': 'Kein Netzwerk festgelegt',
    'l7_stick_table': 'Layer-7-Stick-Tabelle',
    'l7_stick_table_refresh': 'Stick-Tabelle aktualisieren',
    'l7_stick_table_select_backend': 'Backend auswählen:',
    'licence_contact_support': 'Bitte wenden Sie sich an support@loadbalancer.org.',
    'licence_expiration_due': 'Ihre Supportlaufzeit läuft ab in ',
    'licence_expired_guide': 'Bitte geben Sie Ihren neuen Lizenzschlüssel ein oder kontaktieren Sie uns, wenn Sie keinen gültigen Lizenzschlüssel haben.',
    'licence_model': 'Modell',
    'licence_question': 'Haben Sie eine Lizenzierungsfrage?',
    'licence_question_description': 'Wir haben viele Lizenzierungsoptionen, die Ihren Geschäftsbedürfnissen entsprechen. Sprechen Sie noch heute mit einem unserer freundlichen Vertriebsmitarbeiter!',
    'licence_serial_number': 'Seriennummer',
    'licence_support_ends_on': 'Support endet am',
    'licence_support_expires_in': 'Support läuft ab in ',
    'licence_type': 'Lizenztyp',
    'licence_update_key': 'Lizenzschlüssel aktualisieren',
    'licence_widget_core_updates': 'Kernupdates',
    'licence_widget_details': 'Lizenzdetails',
    'licence_widget_expiry': 'Ablauf der Lizenz',
    'licence_widget_lifetime': '(Lebenslang)',
    'licence_widget_security_updates': 'Sicherheitsupdates',
    'licenced': 'Lizenziert',
    'license_expired': 'Ihre Lizenz ist abgelaufen',
    'license_update_license_guide': 'Um Ihren kostenlosen Premium-Technischen Support zu aktivieren, geben Sie bitte einen gültigen Lizenzschlüssel ein. Um Ihren Lizenzschlüssel zu erhalten, kontaktieren Sie uns bitte.',
    'license_warn_remaining_days': 'Der Supportvertrag für dieses Gerät läuft in ',
    'license_warn_support_expired': 'Der Supportvertrag für dieses Gerät ist abgelaufen. ',
    'loadbalancer_cluster_configuration': 'Clusterkonfiguration',
    'loadbalancer_local_config': 'Lokale Konfiguration',
    'loadbalancer_network': 'Netzwerk',
    'loadbalancer_website_link': 'Sie werden zur Loadbalancer-Website weitergeleitet',
    'login': 'Anmelden',
    'login_connection_settings': 'Verbindungseinstellungen',
    'login_error': 'Anmeldefehler',
    'login_host_ip': 'Host-IP',
    'login_invalid_ip': 'Ungültige IP',
    'login_reset_it': 'Zurücksetzen',
    'login_reset_password_message': 'Geben Sie unten Ihre registrierte E-Mail-Adresse ein, um Anweisungen zum Zurücksetzen Ihres Passworts zu erhalten.',
    'login_untrusted_host_certificate': 'Nicht vertrauenswürdiges Host-Zertifikat',
    'login_zero_downtime': 'Keine Ausfallzeit.',
    'logout_confirmation': 'Abmeldebestätigung',
    'logout_warning_title': 'Abmelde-Warnung',
    'logout_warning_message': 'Sie werden abgemeldet in:',
    'logs_clear_services': 'Dienste löschen',
    'logs_comm': 'Kommunikation',
    'logs_date_time_format': 'Datum Zeit (yyyy-mm-dd)',
    'logs_error_data': 'Fehler beim Abrufen von Daten über die API. Bitte kontaktieren Sie den Support.',
    'logs_fetching_data': 'Daten werden abgerufen...',
    'logs_log_config': 'Log-Konfiguration',
    'logs_message': 'Nachricht',
    'logs_no_more': 'Keine weiteren Protokolle vorhanden.',
    'logs_pid': 'PID',
    'logs_reverse': 'Umkehren',
    'logs_start': 'Protokolle starten',
    'logs_uid': 'UID',
    'manage_acl_rules': 'ACL-Regeln verwalten',
    'manage_acls': 'ACLs verwalten',
    'manage_acls_add': 'ACL hinzufügen',
    'manage_acls_no_frontends_or_backends': 'Keine Frontends oder Backends gefunden',
    'manage_acls_no_frontends_or_backends_text': 'Derzeit haben Sie keine Frontends oder Backends. Klicken Sie auf Bestätigen, um zur Seite zur Verwaltung von Diensten zu gelangen, wo Sie einen neuen Dienst erstellen können.',
    'manage_acls_path_type': 'Pfadtyp',
    'manage_acls_redirect_location': 'Umleitungsstandort',
    'manage_acls_redirect_type': 'Umleitungsart',
    'manage_acls_return_to': 'Zurück zur Verwaltung von ACLs',
    'manage_services': 'Dienste verwalten',
    'manage_services_add_layer_4': 'Layer 4-Dienst hinzufügen',
    'manage_services_add_layer_7': 'Layer 7-Dienst hinzufügen',
    'manage_services_add_monitor': 'Monitor hinzufügen',
    'manage_services_delete_selected': 'Ausgewählte Frontends löschen',
    'manage_services_delete_multiple_frontends': 'Mehrere Frontends löschen?',
    'manage_services_deleting': 'Frontends löschen',
    'manage_services_duplicate_monitor': 'Monitor duplizieren',
    'manage_services_edit_layer_4': 'Layer 4-Dienst bearbeiten',
    'manage_services_edit_layer_7': 'Layer 7-Dienst bearbeiten',
    'manage_services_edit_monitor': 'Monitor bearbeiten',
    'manage_services_return': 'Zurück zur Diensteverwaltung',
    'manage_services_view_stick_table': 'Haftungstabelle anzeigen',
    'missing_ip_add_to_complete': 'Die folgende(n) IP-Adresse(n) muss/müssen erstellt werden, um diesen Assistenten abzuschließen.',
    'missing_ip_addresses': 'FIP-Einrichtung',
    'missing_ip_status': 'FIP-Status',
    'missing_ip_submit_new_ips': 'Neue IPs übermitteln',
    'mtls_ca': 'Zertifizierungsstelle',
    'mtls_crl': 'Widerrufsliste',
    'namespace_add': 'Namespace hinzufügen',
    'namespace_edit': 'Namespace bearbeiten',
    'namespace_delete': 'Namespace löschen',
    'namespace_delete_message': 'Möchten Sie diesen Namespace wirklich löschen?',
    'namespaces': 'Namespaces',
    'net_int_config': 'Schnittstellen',
    'net_int_config_add_interface': 'Schnittstelle hinzufügen',
    'net_int_config_add_to_bond': 'Zu Bond hinzufügen',
    'net_int_config_bond_edit': 'Bond bearbeiten',
    'net_int_config_break_bond': 'Bond aufheben',
    'net_int_config_break_bond_backend_message': 'Lassen Sie das Backend automatisch zuweisen',
    'net_int_config_break_bond_cancel_text': 'Zurück zur Net-Int-Konfiguration',
    'net_int_config_break_bond_confirm_message': 'Dieser Bond hat keine Gruppen, und die Schnittstellen werden in ihren ursprünglichen Zustand zurückversetzt.',
    'net_int_config_break_bond_groups_message': 'Weisen Sie bitte IP-Gruppen wieder den Schnittstellen zu.',
    'net_int_config_break_bond_vlans_message': 'Weisen Sie bitte VLANs wieder den Schnittstellen zu.',
    'net_int_config_create_bond': 'Bond hinzufügen',
    'net_int_config_create_bond_message': 'Geben Sie Ihrem Bond einen Namen und wählen Sie die Schnittstellen aus, die gebündelt werden sollen.',
    'net_int_config_delete_vlan': 'VLAN löschen',
    'net_int_config_delete_vlan_message': 'Möchten Sie dieses VLAN wirklich löschen?',
    'net_int_config_edit_vlan': 'VLAN bearbeiten',
    'net_int_config_interface_details': 'Schnittstellendetails',
    'net_int_config_interface_edit': 'Schnittstelle bearbeiten',
    'net_int_config_interface_name': 'Schnittstellennamen',
    'net_int_config_interface_offload': 'Schnittstellenentlastung',
    'net_int_config_interface_remove': 'Schnittstelle aus Bond entfernen',
    'net_int_config_interface_remove_message': 'Möchten Sie diese gebündelte Schnittstelle wirklich entfernen?',
    'net_int_config_ip_add': 'IP hinzufügen',
    'net_int_config_mtu': 'MTU',
    'net_int_config_offload': 'Entlastung',
    'net_int_config_onboot': 'Beim Start',
    'net_int_config_speed': 'Geschwindigkeit',
    'net_int_config_vlan_add': 'VLAN hinzufügen',
    'no_access': 'Zugriff abgelehnt',
    'no_access_instructions': 'Kopieren Sie Folgendes und leiten Sie es an Ihren Systemadministrator weiter, um den Zugriff anzufordern.',
    'no_access_message': 'Leider haben Sie keine Berechtigung, diese Seite anzuzeigen.',
    'no_access_message_access_path': 'versucht auf den Pfad zuzugreifen:',
    'no_access_message_endpoint': 'Der API-Endpunkt ist:',
    'no_access_message_required_method': 'was die Methode erfordert:',
    'no_access_message_user': 'Der Benutzer:',
    'no_access_requirement': 'Zugangsvoraussetzung',
    'notification_clear_selected': 'Ausgewählte Benachrichtigung löschen',
    'notification_copy_debug_info': 'Debug-Informationen kopieren',
    'notifications_clear': 'Alle Benachrichtigungen löschen',
    'notifications_clear_error': 'Fehler löschen',
    'notifications_clear_warning': 'Warnung löschen',
    'notifications_delete_selected': 'Ausgewählte Benachrichtigungen löschen',
    'notifications_see_all': 'Alle Benachrichtigungen anzeigen',
    'onboard_add_adc': 'Loadbalancer hinzufügen',
    'onboard_add_adc_message': 'Wir bieten Loadbalancer-Unterstützung von mehreren Anbietern an. Wählen Sie unten einen aus.',
    'onboard_add_organization': 'Ihre Organisation hinzufügen',
    'onboard_add_organization_message': 'Um das Loadbalancer-Portal zu nutzen, müssen Sie einige Organisationsdetails hinzufügen.',
    'onboard_add_users': 'Benutzer hinzufügen',
    'onboard_add_users_message': 'Sie können mehrere Benutzer einladen, um Ihre Loadbalancer zu verwalten und zu warten.',
    'onboard_continue_to_portal': 'Weiter zum Portal',
    'onboard_current_user': 'Der aktuelle angemeldete Benutzer ist bereits einer Organisation zugeordnet.',
    'onboard_do_it_later': 'Später erledigen',
    'onboard_edit_organization': 'Organisation bearbeiten',
    'onboard_organization_private_key': 'Organisations-Privatschlüssel',
    'onboard_organization_private_key_message': 'Bitte bestätigen Sie Ihr Passwort, um Ihren Organisations-Privatschlüssel herunterzuladen.',
    'onboard_setup_issue_message': 'Wenn Sie Probleme beim Onboarding dieser Organisation haben, versuchen Sie es mit der Schaltfläche Support unten rechts, oder das Bestätigen führt dazu, dass Sie abgemeldet werden und es erneut versuchen können.',
    'onboard_setup_issue_title': 'Problem bei der Einrichtung dieser Organisation',
    'onboard_user_already_assigned': 'Benutzer bereits zugewiesen',
    'organization_change_denied': 'Sie haben keine Berechtigung, diese Details zu ändern.',
    'organization_send_continue': 'Einladung senden und fortsetzen',
    'organization_title': 'Organisation',
    'physical_adv_conf': 'Physisch - erweiterte Konfiguration',
    'physical_adv_conf_conn_trac_table_size': 'Größe der Verbindungsverfolgungstabelle',
    'physical_adv_conf_console': 'Konsole',
    'physical_adv_conf_firewall_connections': 'Firewall-Verbindungen',
    'physical_adv_conf_http_proxy': 'HTTP-Proxy',
    'physical_adv_conf_internet_access': 'Internetzugang',
    'physical_adv_conf_proxy_address': 'Proxy-Adresse',
    'physical_adv_conf_proxy_password': 'Proxy-Passwort',
    'physical_adv_conf_proxy_port': 'Proxy-Port',
    'physical_adv_conf_proxy_username': 'Proxy-Benutzername',
    'physical_adv_conf_smtp_address': 'SMTP-Adresse',
    'physical_adv_conf_smtp_password': 'SMTP-Passwort',
    'physical_adv_conf_smtp_port': 'SMTP-Port',
    'physical_adv_conf_smtp_relay': 'SMTP-Relay',
    'physical_adv_conf_smtp_server_address': 'SMTP-Serveradresse',
    'physical_adv_conf_smtp_username': 'SMTP-Benutzername',
    'pipeline': 'Pipeline',
    'pipeline_add': 'Pipeline hinzufügen',
    'pipelines': 'Pipelines',
    'platform_hyperV_description_long': 'Microsoft Hyper-V ist eine hypervisorbasierte Virtualisierungsplattform, die von Microsoft entwickelt wurde. Sie ermöglicht Benutzern, virtuelle Maschinen (VMs) auf einem auf Windows basierenden System zu erstellen und zu verwalten. Hyper-V ermöglicht es mehreren Betriebssystemen, auf einer einzigen physischen Maschine zu laufen, indem die Hardware-Ressourcen virtualisiert werden.',
    'platform_hyperV_description_short': 'Hyper-V ermöglicht das Ausführen mehrerer Betriebssysteme als virtuelle Maschinen unter Windows. ',
    'platform_kvm_description_long': 'Der KVM-Hypervisor für Kernel-basierte virtuelle Maschinen bietet vollständige Virtualisierungsfähigkeiten. Er stellt jeder VM alle typischen Dienste des physischen Systems zur Verfügung, einschließlich virtuellem BIOS und virtueller Hardware wie Prozessor, Speicher, Speicherplatz und Netzwerkkarten. Dadurch simuliert jede VM vollständig eine physische Maschine.',
    'platform_kvm_description_short': 'KVM stellt jeder VM alle Dienste des physischen Systems und virtuelle Hardware zur Verfügung.',
    'platform_nutanix_description_long': 'Dieser unternehmensbereite Hypervisor von Nutanix ist in jedem Nutanix-Knoten enthalten. Als Hypervisor, der für HCI und die Enterprise Cloud entwickelt wurde, bietet AHV die Möglichkeit, die Softwarelizenzkosten zu senken, ohne dabei Funktionen und Leistung einzuschränken.',
    'platform_nutanix_description_short': 'Nutanix AHV ist ein unternehmensbereiter Hypervisor, der in jedem Nutanix-Knoten enthalten ist. ',
    'platform_virtualBox_description_long': 'Oracle VM VirtualBox ist eine Open-Source, plattformübergreifende Virtualisierungssoftware, mit der Benutzer virtuelle Maschinen auf ihren Hostsystemen erstellen und verwalten können. Entwickelt von Oracle unterstützt VirtualBox eine Vielzahl von Gastbetriebssystemen und ist somit ein vielseitiges Werkzeug für Entwicklung, Tests und das Ausführen mehrerer Betriebssysteme auf einer einzigen physischen Maschine.',
    'platform_virtualBox_description_short': 'VirtualBox ist eine Open-Source-Version des Hypervisors von VMWare.',
    'platform_vmWare_description_long': 'VMware ESXi ist ein Bare-Metal-Hypervisor und eine Virtualisierungsplattform, die von VMware entwickelt wurde. Sie ermöglicht Benutzern, virtuelle Maschinen (VMs) auf einem Server zu erstellen und zu verwalten, ohne dass ein Hostbetriebssystem erforderlich ist. ESXi ist ein Typ-1-Hypervisor, was bedeutet, dass er direkt auf der Hardware läuft und eine effiziente und direkte Steuerung über die Systemressourcen bietet.',
    'platform_vmWare_description_short': 'VMware ESXi ist ein Bare-Metal-Hypervisor, der von VMware für vSphere entwickelt wurde. ',
    'platform_xen_description_long': 'Xen bietet Dienste, die es mehreren Betriebssystemen ermöglichen, gleichzeitig auf derselben Computerhardware ausgeführt zu werden. Der Xen-Projekt-Hypervisor ist ein Open-Source-Typ-1- oder Bare-Metal-Hypervisor, der es ermöglicht, viele Instanzen eines Betriebssystems oder unterschiedliche Betriebssysteme parallel auf einer einzigen Maschine (oder einem Host) auszuführen.',
    'platform_xen_description_short': 'Xen ist ein kostenloser und Open-Source-Typ-1-Hypervisor.',
    'policies_privacy': 'Loadbalancer.org, Inc. Datenschutzrichtlinie',
    'policies_terms_of_service': 'Loadbalancer.org, Inc. Nutzungsbedingungen',
    'portal_management': 'Portalverwaltung',
    'portal_management_adoption_details': 'Adoptionsdetails',
    'portal_management_adoption_status': 'Adoptionsstatus',
    'portal_management_adoption_submitted': 'Adoption eingereicht',
    'portal_management_connection_submitted': 'Verbindungsdetails eingereicht',
    'portal_management_ip_address': 'Verwaltungs-IP-Adresse',
    'portal_management_login_email': 'Portal-Anmelde-E-Mail',
    'portal_management_login_password': 'Portal-Anmeldepasswort',
    'portal_management_not_submitted': 'Nicht eingereicht',
    'portal_management_remove_adc': 'ADC aus Portal entfernen',
    'portal_management_remove_adc_message': 'Sind Sie sicher, dass Sie diesen ADC aus dem Portal entfernen möchten?',
    'portal_management_shuttle_enabled': 'Shuttle aktivieren',
    'portal_management_shuttle_setup': 'Shuttle-Einrichtung und ist bereit für die Adoption',
    'portal_management_subnets': 'Verwaltungssubnetze',
    'prometheus_enable_exporter_ha_proxy': 'Layer 7-Exporter aktiviert',
    'prometheus_enable_exporter_node': 'Node Exporter aktiviert',
    'prometheus_error_duplicate': 'Der Port und die IP können nicht mit dem anderen Exporter identisch sein',
    'prometheus_exporter_port': 'Exporter-Port',
    'prometheus_node_exporter': 'Node Exporter',
    'prometheus_set_exporters': 'Exporter festlegen',
    'pulse_conf_fail_over_limit': 'Die Grenze muss zwischen 2000 und 10000 liegen',
    'pulse_conf_interval': 'Das Intervall muss zwischen 1000 und 10000 liegen',
    'pulse_ha_auto_fail_back': 'Automatisches Zurückfallen',
    'pulse_ha_auto_fail_back_join': 'autoFailBack',
    'pulse_ha_change_ip': 'Um die IP-Adresse und die Portnummer zu ändern, auf die PulseHA hört, müssen Sie diesen Knoten zuerst aus dem Cluster entfernen.',
    'pulse_ha_cluster_health': 'Clusterzustand',
    'pulse_ha_cluster_status': 'PulseHA-Clusterstatus',
    'pulse_ha_config': 'PulseHA-Konfiguration',
    'pulse_ha_current_settings': 'Aktuelle Einstellungen.',
    'pulse_ha_error': 'Es liegt ein Fehler bei PulseHA vor',
    'pulse_ha_fail_over_interval': 'Failover-Intervall*',
    'pulse_ha_fail_over_limit': 'Failover-Grenze*',
    'pulse_ha_global_config': 'PulseHA-Globale Konfiguration',
    'pulse_ha_health_check_interval': 'Intervall für die Gesundheitsüberprüfung*',
    'pulse_ha_node_cluster': 'Dieser Knoten befindet sich in einem Cluster',
    'pulse_ha_port': 'PulseHA-Port',
    'rbac_hint_update_yourself': 'Du kannst deine eigenen Berechtigungen nicht aktualisieren.',
    'rbac_hint_group_association_delete': 'Sie können keine Gruppe löschen, mit der Sie verbunden sind.',
    'rbac_hint_group_association_update': 'Sie können keine Gruppe bearbeiten, mit der Sie verbunden sind.',
    'rbac_hint_role_association_delete': 'Sie können keine Rolle löschen, mit der Sie verbunden sind.',
    'rbac_hint_role_association_update': 'Sie können keine Rolle bearbeiten, mit der Sie verbunden sind.',
    'rbac_group_add_role': 'Gruppe hinzufügen',
    'rbac_group_admin_access_text': 'Admin-Zugriff',
    'rbac_group_assign_role': 'Weisen Sie der Gruppe eine Rolle zu',
    'rbac_group_assign_role_select': 'Rolle auswählen',
    'rbac_group_assign_role_selected': 'Ausgewählte Rolle(n)',
    'rbac_group_delete_role': 'Gruppe löschen',
    'rbac_group_details': 'Gruppendetails',
    'rbac_group_edit_role': 'Gruppe bearbeiten',
    'rbac_group_management': 'Wählen Sie Benutzer aus',
    'rbac_group_management_selected': 'Ausgewählte Benutzer:',
    'rbac_group_name': 'Gruppenname',
    'rbac_group_ready_message': 'Bitte überprüfen Sie Ihre Angaben. Sie können Ihre Daten bearbeiten oder unten auf die Schaltfläche „Senden“ klicken, wenn Sie fertig sind.',
    'rbac_groups_add_group': 'Gruppe hinzufügen',
    'rbac_groups_cancel_text': 'Zurück zu den Gruppen',
    'rbac_groups_delete_group': 'Gruppe löschen',
    'rbac_groups_edit_group': 'Gruppe bearbeiten',
    'rbac_groups_no_roles': 'Sie haben keine Gruppen oder Rollen eingerichtet',
    'rbac_groups_selected_groups': 'Ausgewählte Gruppen',
    'rbac_role_details': 'Rollendetails',
    'rbac_role_duplicate': 'Doppelte Rolle',
    'rbac_role_duplicated_from': 'Dupliziert von',
    'rbac_role_management': 'Rollenmanagement',
    'rbac_role_name': 'Rollenname',
    'rbac_role_ready_message': 'Bitte überprüfe deine Details. Sie können Ihre Daten bearbeiten oder unten auf die Schaltfläche „Senden“ klicken, wenn Sie fertig sind.',
    'rbac_roles_add_role': 'Rolle hinzufügen',
    'rbac_roles_admin_access_text': 'Administrativer Zugriff',
    'rbac_roles_cancel_text': 'Zurück zu den Rollen',
    'rbac_roles_delete_role': 'Rolle löschen',
    'rbac_roles_edit_collapse_all': 'Alles einklappen',
    'rbac_roles_edit_expand_all': 'Alle erweitern',
    'rbac_roles_edit_role': 'Rolle bearbeiten',
    'rbac_users_add_user': 'Benutzer hinzufügen',
    'rbac_users_delete_selected': 'Ausgewählte Benutzer löschen',
    'rbac_users_details': 'Nutzerdetails',
    'rbac_users_disable_user': 'Benutzer deaktivieren',
    'rbac_users_edit_user': 'Benutzer bearbeiten',
    'rbac_users_edit_user_permissions': 'Benutzerberechtigungen bearbeiten',
    'rbac_users_invite_user': 'Benutzer einladen',
    'rbac_users_ready': 'Bereit, einen Benutzer hinzuzufügen',
    'rbac_users_return_to_users': 'Zurück zu den Benutzern',
    'rbac_users_roles_groups_message': 'Sie müssen mindestens eine Rolle oder Gruppe  hinzufügen, um fortzufahren.',
    'rbac_users_submit_user': 'Benutzer übermitteln',
    'rbac_users_submit_user_warning': 'Sie bearbeiten das Passwort des aktuellen Benutzers. Durch die Übermittlung müssen Sie sich erneut mit Ihrem neuen Passwort anmelden. Möchten Sie fortfahren?',
    'rbac_users_update_message': 'Ein Benutzer kann seine persönlichen Daten in den Kontoeinstellungen bearbeiten',
    'rbac_users_update_permissions': 'Berechtigungen aktualisieren',
    'rbac_widget_no_permissions': 'Sie haben keine Berechtigung, dieses Widget anzuzeigen',
    'region_add': 'Region hinzufügen',
    'region_add_new': 'Neue Region hinzufügen',
    'region_delete': 'Region löschen',
    'region_delete_multiple_regions': 'Mehrere Regionen löschen',
    'region_delete_selected_subnets': 'Ausgewählte Subnetze löschen',
    'region_deleting_regions': 'Regionen löschen',
    'region_edit': 'Region bearbeiten',
    'region_no_subnets_hint': 'Keine Subnetze zum Anzeigen',
    'region_view_subnets': 'Subnetz(e) anzeigen',
    'registration_already_have_account': 'Sie haben bereits ein Konto?',
    'registration_error': 'Registrierungsfehler',
    'registration_policy_message': 'Indem Sie auf Konto erstellen klicken, stimmen Sie unseren',
    'registration_sign_up_message': 'Melden Sie sich noch heute für eine kostenlose Loadbalancer-Erfahrung an',
    'registration_success_msg': 'Erfolg! Wir haben Ihnen eine Aktivierungs-E-Mail gesendet, um Ihre Registrierung zu überprüfen und abzuschließen.',
    'registration_title': 'Registrieren Sie sich für das Portal.',
    'relogin-sso-click': 'Klicken Sie hier, um sich erneut mit SSO anzumelden.',
    'relogin_cert_expired_text': 'Ihr Zertifikat ist abgelaufen. Bitte melden Sie sich ab',
    'relogin_requesting_auth_token': 'AUTH-Token anfordern',
    'reports_distribution_state': 'Verteilungszustand',
    'resources_no_images_available': 'Derzeit gibt es keine Bilder für die ausgewählte Plattform',
    'restart_page_sub_title': 'Dies kann einige Minuten dauern. Bitte warten Sie und Sie werden nach Abschluss zur Anmeldeseite weitergeleitet.',
    'restart_page_title': 'System wird neu gestartet',
    'routing_add_route': 'Route hinzufügen',
    'routing_default_gateway': 'Standard-Gateway',
    'routing_delete_route': 'Route löschen',
    'routing_static_routes': 'Statische Routen',
    'routing_via_interface': 'Über die Schnittstelle',
    'saml_download_xml': 'XML herunterladen',
    'saml_modal_message': 'Bitte geben Sie Ihre Organisations-E-Mail-Adresse ein',
    'saml_modal_title': 'SAML-Anmeldung',
    'saml_remove_message': 'Möchten Sie die SAML-Konfiguration wirklich aus Ihrer Organisation entfernen?',
    'saml_remove_title': 'SAML-Konfiguration entfernen',
    'saml_setup_form_label': 'Fügen Sie hier Ihren Metadatenlink ein:',
    'saml_setup_form_enforce': 'Erzwingen Sie SAML für alle Benutzer',
    'saml_setup_message': 'Wenn Sie unsicher sind, wie Sie den SAML-Zugriff konfigurieren sollen, wenden Sie sich bitte an unser Support-Team.',
    'saml_setup_need_help': 'Brauchen Sie Hilfe?',
    'saml_title': 'SAML',
    'saml_title_entityId': 'Entitäts-ID/Zuschauer-URL',
    'saml_title_issuer': 'Aussteller-ID',
    'saml_title_message': 'SAML ermöglicht die Anmeldung über die Single Sign-On-Funktionalität Ihres SAML-Identitätsanbieters.',
    'saml_title_message_help': 'Für Hilfe zur Konfiguration von SAML',
    'saml_title_message_help_link': 'kontaktieren Sie unser Support-Team',
    'saml_title_name_id': 'Name-ID-Format',
    'saml_title_sso_url': 'Single Sign-On-URL',
    'saml_title_what_is': 'Was ist SAML?',
    'saml_title_xml_message': 'Wenn Ihr SAML-Identitätsanbieter die automatische Konfiguration unterstützt, können Sie die Konfiguration unten im XML-Format herunterladen.',
    'saml_upgrade_message': 'Erhöhen Sie die Sicherheit Ihrer Organisation, indem Sie SAML für Ihren Portalzugriff verwenden. Es ist gut!',
    'saml_upgrade_title': 'Upgrade zur Verwendung von SAML',
    'schedule_add': 'Zeitplan hinzufügen',
    'schedule_clear_filters': 'Filter löschen',
    'schedule_create': 'Zeitplan erstellen',
    'schedule_delete': 'Zeitplan löschen',
    'schedule_delete_message': 'Möchten Sie diesen Zeitplan wirklich löschen?',
    'schedule_edit': 'Zeitplan bearbeiten',
    'schedule_type': 'Zeitplantyp',
    'schedule_update': 'Zeitplan aktualisieren',
    'scheduled_date_time': 'Geplantes Datum/Uhrzeit',
    'scheduled_date_time_utc': 'Koordinierte Weltzeit',
    'scheduled_type': 'Geplanter Typ',
    'scheduled_update': 'Geplantes Update',
    'scheduler': 'Zeitplaner',
    'scheduler_error_message_no_adc': 'Kein ADC mit dieser ID vorhanden',
    'scheduler_local_time': 'Ortszeit',
    'scheduler_save_schedule': 'Zeitplan speichern',
    'schedules_empty_message': 'Legen Sie einen geeigneten Zeitpunkt für die Aktualisierung und Sicherung Ihrer Geräte fest, mit einer Historie von einem Jahr.',
    'schedules_empty_title': 'Noch keine Zeitpläne hinzugefügt.',
    'schedules_upgrade_message': 'Zeitpläne ermöglichen es Ihnen, Ihre ADCs zu sichern und zu aktualisieren, wann immer Sie möchten und auf regelmäßiger Basis.',
    'schedules_upgrade_title': 'Upgrade auf Anlagenplanung.',
    'search_no_results': 'Keine Ergebnisse gefunden für',
    'security': 'Sicherheit',
    'security_affected_version': 'Betroffene Version(en)',
    'security_certs_upgrade_message': 'Verbessern Sie die Sicherheit Ihrer Organisation, indem Sie Zertifikate für Ihr Portal verwenden.',
    'security_certs_upgrade_title': 'Aktualisieren Sie, um Zertifikate zu erstellen.',
    'security_cve_details': 'CVE-Details',
    'security_dashboard': 'Dashboard',
    'security_how_to_fix': 'Wie man es behebt',
    'security_insights': 'Einblicke',
    'security_insights_label': 'Sicherheitseinblicke',
    'security_insights_upgrade_message': 'Erhöhen Sie die Sicherheit Ihrer Organisation, indem Sie Einblicke für Ihr Portal verwenden. Es ist gut!',
    'security_insights_upgrade_title': 'Upgrade zur Verwendung von Einblicken',
    'security_more_details': 'Weitere Details',
    'security_need_help': 'Brauchen Sie Hilfe?',
    'security_nist_details': 'NIST-Details',
    'security_operational_risk': 'Betriebsrisiko',
    'security_our_recommendation': 'Unsere Empfehlung',
    'security_published': 'Veröffentlicht',
    'security_published_last': 'Zuletzt geändert',
    'security_publisher': 'Veröffentlicher',
    'security_risk': 'Sicherheitsrisiko',
    'security_severity_score': 'Schweregradscore',
    'security_update_adc': 'ADC aktualisieren',
    'security_vulnerability_id': 'Schwachstellen-ID',
    'security_update_adc_message': 'Das Update wird für diesen Anbieter noch nicht unterstützt',
    'security_vulnerability_info': 'Schwachstelleninformationen',
    'service_details': 'Servicedetails',
    'service_details_add_backend': 'Hinzufügen von Backend',
    'service_details_add_backend_disabled': 'Layer 4 unterstützt derzeit keine mehreren Backends',
    'service_details_edit_backend': 'Backend bearbeiten',
    'service_details_error_type': 'Keine passenden Servicetypen',
    'services_abort_on_close': 'Abbrechen bei Schließen',
    'services_accept_invalid_http_requests': 'Ungültige HTTP-Anfragen akzeptieren',
    'services_accept_invalid_http_response': 'Ungültige HTTP-Antwort akzeptieren',
    'services_add_backend_service': 'Backend-Dienst hinzufügen',
    'services_add_real_server': 'Echten Server hinzufügen',
    'services_agent_port': 'Agentenport',
    'services_application_cookie_name': 'Name des Anwendungscookies',
    'services_apply_all': 'Alle anwenden',
    'services_backend_connections': 'Verbindungen zum Backend',
    'services_backend_mode_disabled_message': 'Der Backend-Modus ist deaktiviert, da das/die verknüpfte(n) Frontend(s) HTTP ist/sind.',
    'services_backend_source_address': 'Quelladresse des Backends',
    'services_balance_mode': 'Balance-Modus',
    'services_check_port': 'Prüfport',
    'services_clear_stick_table_on_drain': 'Stick-Tabelle bei Ablauf leeren',
    'services_client_connection_timeout': 'Timeout für Clientverbindungen',
    'services_compression': 'Kompression',
    'services_backend_configuration': 'Backend-Konfiguration',
    'services_conn_distribution_method': 'Verteilungsmethode für Verbindungen',
    'services_connection_redispatch': 'Verbindungsumleitung',
    'services_count': 'Anzahl',
    'services_delete': 'Dienst löschen',
    'services_disabled_on_start': 'Beim Start deaktiviert',
    'services_drain': 'Dienst ablaufen lassen',
    'services_duplicate_backend_service': 'Duplizieren des Backend-Dienstes',
    'services_duplicate_frontend': 'Frontend duplizieren',
    'services_duplicate_real_server': 'Echten Server duplizieren',
    'services_edit_backend_service': 'Backend-Dienst bearbeiten',
    'services_edit_frontend': 'Frontend bearbeiten',
    'services_edit_real_server': 'Echten Server bearbeiten',
    'services_enable_client_conn_timeout': 'Timeout für Clientverbindungen aktivieren',
    'services_enable_duplicates': 'Duplikate aktivieren',
    'services_enable_gzip_compression': 'Gzip-Kompression aktivieren',
    'services_enable_hsts': 'HSTS aktivieren',
    'services_enable_server_conn_timeout': 'Timeout für Serververbindungen aktivieren',
    'services_enable_ssl_termination': 'SSL-Terminierung aktivieren',
    'services_enable_tproxy': 'TProxy aktivieren',
    'services_enable_x_forwarded': 'X-Forwarded-for-Header aktivieren',
    'services_enable_zero_round_trips': 'Null-Rundreisen aktivieren',
    'services_encrypt_to_real_server': 'Verschlüsseln zum echten Server',
    'services_ensure_requests_untouched': 'Stellen Sie sicher, dass alle 0-RTT-Anfragen unverändert bleiben (die Anfrage kann mehrmals durchgeführt werden, ohne ein anderes Ergebnis zu erzielen), bevor Sie diese Funktion aktivieren',
    'services_external_check_script': 'Externes Prüfskript',
    'services_feedback_agent_interval': 'Intervall für Feedback-Agenten',
    'services_force_to_https': 'Zwingen zu HTTPS',
    'services_frontend_configuration': 'Frontend-Konfiguration',
    'services_frontend_floating_ip': 'Dies ist die IP-Adresse des schwebenden Frontend und die Maske für die schwebende IP.',
    'services_frontend_floating_port': 'Dies sind die Ports der schwebenden IP-Adresse des Frontend.',
    'services_frontend_mode_disabled_message': 'Der Frontend-Modus ist deaktiviert, da das/die verknüpfte(n) Backend(s) TCP ist/sind.',
    'services_greater_than': 'Größer als',
    'services_greater_than_equals': 'Größer als oder gleich',
    'services_halt': 'Dienst anhalten',
    'services_health_check_type': 'Typ der Gesundheitsprüfung',
    'services_host_header': 'Host-Header',
    'services_hsts_timeout': 'HSTS-Timeout',
    'services_http_cookie_max_idle': 'Maximale Inaktivität des HTTP-Cookies',
    'services_http_cookie_max_life': 'Maximale Lebensdauer des HTTP-Cookies',
    'services_http_cookie_name': 'Name des HTTP-Cookies',
    'services_http_idle_connection_reuse': 'Wiederverwendung inaktiver HTTP-Verbindungen',
    'services_http_pipeline_mode': 'Pipeline-Modus für HTTP',
    'services_http_pretend_keepalive': 'Vortäuschen von HTTP-Keepalive',
    'services_http_request_timeout': 'Timeout für HTTP-Anfragen (DDos-Schutz)',
    'services_https_redirect_code': 'HTTPS-Weiterleitungscode',
    'services_individual_ports': 'Individuelle Port(s)',
    'services_layer_4_mode': 'Layer 4-Modus',
    'services_layer_7_mode': 'Layer 7-Modus',
    'services_less_than': 'Kleiner als',
    'services_less_than_equals': 'Kleiner als oder gleich',
    'services_min_real_servers': 'Mindestens echte Server',
    'services_minimum_conns': 'Mindestverbindungen',
    'services_mode': 'Dienstmodus',
    'services_monitor_configuration': 'Monitor-Konfiguration',
    'services_monitor_uri': 'Überwachungs-URI',
    'services_name': 'Dienstname',
    'services_no_backends': 'Keine Backends gefunden',
    'services_notification_changes': 'Die Konfiguration der folgenden Dienste wurde geändert:',
    'services_notification_commit_message': 'Klicken Sie hier, um die Serviceseite zu besuchen und Ihre Änderungen zu übernehmen.',
    'services_number_of_servers': 'Anzahl realer servers',
    'services_number_real_servers_message': 'Die Anzahl der echten Server, die Sie erstellen möchten.',
    'services_online': 'Online-Dienst',
    'services_port_ranges': 'Portbereiche',
    'services_ports_placeholder': 'Ports',
    'services_proxy_protocol': 'Proxy-Protokoll',
    'services_re_encrypt_to_backend': 'Erneut verschlüsseln zum Backend',
    'services_real_server': 'Echter Server',
    'services_real_server_add': 'Fügen Sie einen echten Server hinzu',
    'services_real_server_configuration': 'Echte Serverkonfiguration',
    'services_real_server_confirm_message': 'Möchten Sie die Änderungen am Formular wirklich verlieren?',
    'services_real_server_confirm_title': 'Bestätigen Sie, dass die Änderungen verloren gehen',
    'services_real_server_ip': 'IP-Adresse',
    'services_real_server_name': 'Bezeichnung des echten Servers',
    'services_real_server_port': 'Port des echten Servers',
    'services_real_server_select': 'Wählen Sie den vorhandenen realen Server aus',
    'services_real_server_usage': 'Echte Servernutzung',
    'services_real_servers': 'Echte Server',
    'services_request_to_send': 'Anfrage senden',
    'services_response_expected': 'Erwartete Antwort',
    'services_restart': 'Systemdienste neu starten',
    'services_return_to_service_details': 'Zurück zu den Dienstdetails',
    'services_search_backend': 'Suche innerhalb dieses Backends',
    'services_send_proxy_protocol': 'Proxy-Protokoll senden',
    'services_server_timeout': 'Server-Timeout',
    'services_slow_start_time': 'Zeit für langsamen Start',
    'services_table_size': 'Tabellengröße',
    'services_tcp_keep_alive': 'TCP-Keepalive',
    'services_tcp_keepalive': 'TCP-Keepalive',
    'services_timeout': 'Timeout',
    'services_tunnel_timeout': 'Timeout für Tunnel',
    'services_xff_ip_position': 'Position der XFF-IP',
    'shutdown_completed_page_title': 'Herunterfahren abgeschlossen',
    'shutdown_completed_sub_title': 'Das Herunterfahren des Systems wurde erfolgreich abgeschlossen.',
    'shutdown_page_sub_title': 'Ihr System wird jetzt heruntergefahren.',
    'shutdown_page_title': 'System herunterfahren',
    'shuttle_install_complete': 'Erfolgreich verbunden',
    'shuttle_install_message_credentials': 'Besuchen Sie bitte die Portalverwaltungsseite auf Ihrem Gerät und füllen Sie das Annahmeformular aus.',
    'shuttle_install_message_token': 'Bitte besuchen Sie das Gerät, das Sie als Shuttle einrichten, und führen Sie das obige kopierte Befehl aus.',
    'shuttle_install_wait': 'Warten auf Annahme...',
    'shuttle_no_vendor_message': 'Der ausgewählte Anbieter entspricht nicht unserer Liste unterstützter Anbieter.',
    'shuttle_no_vendor_title': 'Kein Anbieter gefunden',
    'snmp_conf_delete_user_message': 'Sind Sie sicher, dass Sie diesen Benutzer aus Ihrer Konfiguration löschen möchten?',
    'snmp_conf_protocol_in_use': 'Verwendetes Protokoll:',
    'snmp_conf_select_version': 'Protokollversion auswählen',
    'snmp_conf_settings_add': 'SNMP-Einstellungen hinzufügen',
    'snmp_conf_settings_edit': 'SNMP-Einstellungen bearbeiten',
    'snmp_conf_snmp_auth_passphrase': 'Autorisierungs-Passphrase',
    'snmp_conf_snmp_community': 'SNMP-Community',
    'snmp_conf_snmp_contact': 'SNMP-Kontakt',
    'snmp_conf_snmp_enable_v2': 'V2',
    'snmp_conf_snmp_enable_v3': 'V3',
    'snmp_conf_snmp_location': 'SNMP-Standort',
    'snmp_conf_snmp_privacy_alg': 'Privatsphäre-Algorithmus',
    'snmp_conf_snmp_privacy_passphrase': 'Privatsphäre-Passphrase',
    'snmp_conf_snmp_protocol_version': 'Protokollversion SNMP',
    'socket_service_reconnect_message': 'Versuche, die WebSocket-Verbindung wiederherzustellen',
    'ssl_certificates': 'SSL-Zertifikate',
    'ssl_certificates_usage': 'SSL-Zertifikatverwendung',
    'ssl_cipher_lists': 'SSL-Chiffre-Listen',
    'ssl_offload_allowed_hostnames': 'Erlaubte Hostnamen',
    'ssl_offload_cipher_list': 'Chiffrenliste',
    'ssl_offload_delete_certificate': 'Zertifikat löschen',
    'ssl_offload_delete_termination_title': 'SSL-Zertifikatzuordnung löschen',
    'ssl_offload_denied_hostnames': 'Verweigerte Hostnamen',
    'ssl_offload_hostnames_add_allowed': 'Hinzufügen erlaubt',
    'ssl_offload_hostnames_add_denied': 'Hinzufügen verweigert',
    'ssl_offload_hostnames_allowed': 'Erlaubte Hostnamen',
    'ssl_offload_hostnames_denied': 'Verweigerte Hostnamen',
    'ssl_offload_hostnames_placeholder': 'Hostname(s)',
    'ssl_offload_manage_certificate': 'Zertifikat verwalten',
    'ssl_offload_manage_cipher_list': 'Chiffrenliste verwalten',
    'ssl_offload_remove_ssl_cert_association': 'SSL-Zertifikatzuordnung entfernen',
    'ssl_offload_remove_ssl_cert_association_message': 'Durch Löschen dieser SSL-Zertifikatszuordnung wird die SSL-Terminierung deaktiviert. Möchten Sie diese SSL-Zertifikatszuordnung wirklich löschen?',
    'static_ip': 'Statische IP',
    'static_ip_add': 'Statische IP hinzufügen',
    'static_ip_change': 'IP geändert',
    'static_ip_change_message': 'Die IP, die Sie ändern, ist einem Dienst zugewiesen und dieser Dienst muss neu geladen werden.',
    'static_ip_delete_multiple_ips': 'Mehrere IPs löschen',
    'static_ip_delete_selected': 'Ausgewählte statische IPs löschen',
    'static_ip_edit': 'Statische IP bearbeiten',
    'static_ip_no_usage': 'Keine Nutzungsdaten verfügbar',
    'static_ip_not_in_use': 'Nicht in Benutzung',
    'static_ip_usage': 'Nutzung statischer IP-Adressen',
    'static_ip_usage_for_ip': 'Nutzung für IP',
    'static_ip_used_in': 'Verwendet in',
    'static_route': 'Route',
    'static_route_add': 'Route hinzufügen',
    'static_route_default_gw_change': 'Ändern Sie die Gateway-Adresse der Standardroute',
    'static_route_default_gw_change_message': 'Sie sind dabei, das Gateway der Standardroute zu ändern. Sind Sie sicher, dass Sie dies tun möchten?',
    'static_route_delete': 'Statische Route löschen',
    'static_route_delete_multiple_routes': 'Mehrere Routen löschen',
    'static_route_delete_selected': 'Ausgewählte Routen löschen',
    'static_route_edit': 'Route bearbeiten',
    'static_route_gateway': 'Gateway',
    'static_route_group': 'Gruppe',
    'static_route_range': 'IP-Bereich',
    'static_route_type': 'Typ',
    'static_routes': 'Routen',
    'storage_download_latest': 'Neueste herunterladen',
    'storage_download_restriction_notification': 'Sie verfügen aktuell über keinen Organisationsschlüssel, Sie müssen diesen bei Ihrem Administrator anfordern.',
    'storage_empty_message': 'Wenn Sie ein Backup Ihres ADC oder anderer Dienste erstellen, wird es hier angezeigt.',
    'storage_empty_title': 'Noch keine Backups hinzugefügt.',
    'storage_modal_id_message': 'Die ADC-Geräte-ID wird als Passwort für die verschlüsselte Datei benötigt. Ohne diese ID können Sie das Backup nicht verwenden:',
    'storage_modal_id_title': 'Passwort für Backup-Archiv',
    'subscriptions_adc_connections': 'ADC-Verbindungen',
    'subscriptions_add_more_connections': 'Fügen Sie Ihrem Portal zusätzlich 10 ADC-Verbindungen hinzu',
    'subscriptions_annual_plan': 'Jahresplan',
    'subscriptions_backup_history': 'Mit 1 Jahr Geschichte',
    'subscriptions_billed_at': 'Abgerechnet bei',
    'subscriptions_book_a_demo': 'Buchen Sie eine Demo',
    'subscriptions_business': 'Portalgeschäft',
    'subscriptions_business_subtitle': 'Für mehrere Teams',
    'subscriptions_current_plan': 'Aktueller Plan',
    'subscriptions_enterprise_demo_message': 'Bereit für Unternehmen! Kontaktieren Sie unser Team für ein individuelles Angebot.',
    'subscriptions_for_starter_projects': 'Für Starterprojekte',
    'subscriptions_free': 'Portal kostenlos',
    'subscriptions_monthly_plan': 'Monatspläne',
    'subscriptions_need_more_connections': 'Brauchen Sie mehr Verbindungen?',
    'subscriptions_per_adc': 'pro ADC',
    'subscriptions_pro': 'Pro-Portal',
    'subscriptions_pro_subtitle': 'Für Profis',
    'subscriptions_support_level': 'Unterstützungsstufe',
    'subscriptions_support_message': 'Portalplattform (In Ihrer Zeitzone)',
    'subscriptions_support_type': 'Konto und Abrechnung',
    'subscriptions_tailored': 'Portal maßgeschneidert',
    'subscriptions_tailored_subscription_message': 'Unser maßgeschneidertes Abonnement ist für große Unternehmen konzipiert. Buchen Sie noch heute eine kostenlose Demo bei uns.',
    'subscriptions_tailored_subtitle': 'Für eine vollständige Individualisierung',
    'support': 'Unterstützung',
    'support_close_ticket': 'Ticket schließen',
    'support_close_ticket_message': 'Möchten Sie dieses Ticket wirklich schließen? Es wird nicht mehr in den Tickets Ihrer Organisation angezeigt.',
    'support_create_ticket': 'Ticket erstellen',
    'support_delete_ticket': 'Ticket löschen',
    'support_get': 'Holen Sie sich Unterstützung',
    'support_send_feedback': 'Feedback senden',
    'support_technical_archive_success': 'Supportarchiv heruntergeladen',
    'support_technical_contact_us': 'Kontaktieren Sie uns',
    'support_technical_create_support_archive': 'Erstellen von Supportarchiven. Bitte warten...',
    'support_technical_create_support_archive_error': 'Beim Erstellen des Supportarchivs ist ein Fehler aufgetreten.',
    'support_technical_download_info': 'Diese Seite generiert ein Archiv aller erforderlichen Dateien, das dann auf Ihren PC heruntergeladen wird.',
    'support_technical_info': 'Wenn Sie den Support von Loadbalancer.org kontaktieren, kann es sein, dass Sie die Konfigurations- und Protokolldateien des Loadbalancers bereitstellen müssen.',
    'support_technical_recommended': 'Wir haben bereits die empfohlene Downloadoption für Sie ausgewählt.',
    'support_technical_support_download': 'Technischer Support-Download',
    'support_telephone': 'Telefonischer Support',
    'support_tickets_empty_message': 'Sie haben derzeit keine Support-Tickets zum Anzeigen.',
    'support_tickets_empty_title': 'Keine Support-Tickets',
    'system_control_confirm_restart': 'Sind Sie sicher, dass Sie den Lastenausgleicher neu starten möchten?',
    'system_control_confirm_shutdown': 'Sind Sie sicher, dass Sie den Lastenausgleicher herunterfahren möchten?',
    'system_control_confirm_unlock': 'Sind Sie sicher, dass Sie Ihren Lastenausgleicher entsperren möchten?<br>Wenn er aus einem echten Grund gesperrt ist, könnten Sie Ihr Gerät beschädigen!',
    'system_control_logout_info': 'Sie werden aus dem Client ausgeloggt',
    'system_control_reboot_load_balancer_message': 'Ihr Lastenausgleich wird neu gestartet und in Kürze wieder online sein',
    'system_control_restart_lb': 'Lastenausgleicher neu starten',
    'system_control_shutdown_lb': 'Lastenausgleicher herunterfahren',
    'system_control_unlock': 'Entsperren',
    'system_control_view_error_log': 'Fehlerprotokoll anzeigen',
    'system_control_error_log': 'Fehlerprotokoll',
    'system_overview': 'Systemübersicht',
    'system_overview_details': 'Systemdetails',
    'system_update_change_log': 'Änderungsprotokoll',
    'system_update_confirm_unlock': 'Sind Sie sicher, dass Sie Ihren Lastenausgleicher entsperren möchten?<br>Wenn er aus einem echten Grund gesperrt ist, könnten Sie Ihr Gerät beschädigen!',
    'system_update_confirm_update_message': 'Sind Sie sicher, dass Sie den Lastenausgleicher aktualisieren möchten?',
    'system_update_current_version': 'Aktuelle Version',
    'system_update_failed': 'Verbindung mit dem Repository konnte nicht hergestellt werden. Nur manuelle Updates möglich.',
    'system_update_manual_update': 'Manuelles Update',
    'system_update_online_update': 'Online-Update',
    'system_update_os_update': 'Betriebssystemupdate',
    'system_update_os_version': 'Betriebssystemversion',
    'system_update_package_to_update': 'Zu aktualisierende Pakete: ',
    'system_update_package_to_update_major': 'Hauptversion zu aktualisierende: ',
    'system_update_package_update_failed': 'Paketaktualisierung fehlgeschlagen',
    'system_update_package_updating': 'Aktualisiere Pakete',
    'system_update_package_wait': 'Bitte warten.....',
    'system_update_pending_version': 'Ausstehende Version',
    'system_update_release': 'Veröffentlichung',
    'system_update_restart': 'Ihr Loadbalancer erfordert einen Neustart',
    'system_update_restart_required': 'Ein oder mehrere Pakete erfordern einen Neustart Ihres Lastenausgleichs. Durch Klicken auf Neustart werden Sie ausgeloggt. Ihr Lastenausgleicher ist möglicherweise einige Minuten nicht verfügbar',
    'system_update_software_update': 'Softwareupdate',
    'system_update_system_packages_up_to_date': 'Alle Pakete sind auf dem neuesten Stand',
    'system_update_system_up_to_date': 'Alles ist auf dem neuesten Stand',
    'system_update_update_archive': 'Bitte wählen Sie das Update-Archiv aus',
    'system_update_version': 'Versionsnummer',
    'system_updates': 'Systemupdates',
    'tab_no_access': 'Sie haben keinen Zugriff, um diesen Tab anzusehen.',
    'table_close_overlay': 'Tabellenüberlagerung schließen',
    'table_component_all': 'Alle ',
    'table_component_all_selected_page': ' Datensätze auf dieser Seite sind ausgewählt.',
    'table_component_are_selected': ' ausgewählt.',
    'table_component_clear_selection': 'Auswahl aufheben.',
    'table_go_to_page': 'Gehe zur Seite',
    'table_hidden_columns': 'Ausgeblendete Spalten',
    'table_landscape_on_small_devices': 'Querformat auf kleinen Geräten',
    'table_no_data': 'Keine Daten vorhanden',
    'table_show_records': 'Datensätze anzeigen',
    'tables_are_best_viewed': 'Tabellen werden am besten angezeigt in',
    'tags': 'Tags',
    'tags_duplicate_message': 'Dieser Tag existiert bereits (möglicherweise in Kleinbuchstaben)',
    'tags_max-length_message': 'Dieser Tag ist zu lang, maximaler Buchstabe',
    'tags_max_message': 'Sie haben die maximale Anzahl von Tags erreicht',
    'tags_min-length_message': 'Dieser Tag ist zu kurz',
    'tags_place_holder': 'Fügen Sie einen Tag hinzu und drücken Sie Enter',
    'template_selector_import_template': 'Vorlage importieren',
    'template_selector_load_saved_template': 'Gespeicherte Vorlage laden',
    'template_selector_remove_template': 'Vorlage entfernen',
    'template_selector_select_service_type': 'Bitte wählen Sie eine Vorlage zum Konfigurieren aus',
    'ticket': 'Ticket',
    'ticket_type': 'Tickettyp',
    'ticket_update': 'Ticket aktualisieren',
    'tickets_all': 'Alle Tickets',
    'update_settings': 'Einstellungen aktualisieren',
    'upload_change_file': 'Datei ändern',
    'upload_choose_file': 'Datei auswählen',
    'upload_pem_pfx': 'Hochladen (PEM / PFX)',
    'upload_update_pem': 'PEM aktualisieren',
    'upload_update_pem_pfx': 'Aktualisieren (PEM / PFX)',
    'upload_update_pfx': 'PFX aktualisieren',
    'usage_no_usage': 'Keine Nutzungsdaten verfügbar',
    'usage_not_in_use': 'Nicht in Benutzung',
    'usage_used_in': 'In Benutzung bei',
    'user_activation_passcode_invite_message': 'Ihr Eingeladener benötigt einen einmaligen Passcode, um sein Konto zu aktivieren. Bitte machen Sie sich eine Notiz davon und senden Sie ihn ihnen zu.',
    'user_add_new_user_message': 'Bitte geben Sie Ihr Passwort ein, um die Einladung zu senden',
    'user_copy_passcode': 'Passcode kopieren',
    'user_delete_group': 'Gruppe löschen',
    'user_delete_group_message': 'Sind Sie sicher, dass Sie diese Gruppe löschen möchten?',
    'user_delete_message_endurance': 'Sind Sie sicher, dass Sie diesen Benutzer von dieser Appliance löschen möchten?',
    'user_delete_message_portal': 'Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?',
    'user_delete_users_message_portal': 'Möchten Sie die ausgewählten Benutzer wirklich löschen?',
    'user_delete_portal': 'Benutzerzuordnung löschen',
    'user_delete_role': 'Rolle löschen',
    'user_delete_role_message': 'Sind Sie sicher, dass Sie diese Rolle löschen möchten?',
    'user_hint_delete': 'Sie können den einzigen Eigentümer nicht löschen',
    'user_hint_delete_yourself': 'Sie können sich nicht selbst löschen',
    'user_hint_edit': 'Sie können den einzigen Eigentümer nicht bearbeiten',
    'user_interface': 'Benutzeroberfläche',
    'user_interface_api_port': 'API-Port',
    'user_interface_confirm': 'Benutzeroberfläche bestätigen',
    'user_interface_reload_model_text': 'Httpd und PulseHA werden neu geladen. Sie werden ausgeloggt und in',
    'user_interface_set_interface': 'Benutzeroberfläche setzen',
    'user_interface_ssh_enabled': 'SSH aktiviert',
    'user_interface_ssh_port': 'SSH-Port',
    'user_management': 'Benutzerverwaltung',
    'user_please_confirm_copy_passcode': 'Bitte bestätigen Sie, dass Sie den Passcode kopiert haben',
    'user_send_invite': 'Einladung senden',
    'users_add_user': 'Benutzer hinzufügen',
    'users_edit_user': 'Benutzer bearbeiten',
    'users_list_last_login_in': 'Zuletzt angemeldet',
    'users_list_last_otp_enabled': 'OTP aktiviert',
    'view_config': 'Konfiguration anzeigen',
    'view_config_certs': 'Zertifikate',
    'view_config_ciphers': 'Chiffren',
    'view_config_data_services': 'Dienste für Daten',
    'view_config_fallback_server': 'Fallback-Seiten',
    'view_config_fip': 'FIPs',
    'view_config_gslb': 'GSLB',
    'view_config_haproxy': 'HAProxy',
    'view_config_haproxy_message': 'Layer-7-Konfigurationsdatei konnte nicht abgerufen werden',
    'view_config_healthchecks': 'Gesundheitsprüfungen',
    'view_config_ip_groups': 'IP-Gruppen',
    'view_config_ipvsdirector': 'IP Virtual Service Director',
    'view_config_lbconfig': 'JSON-Konfigurationsdatei',
    'view_config_lbconfig_message': 'JSON-Konfigurationsdatei konnte nicht abgerufen werden',
    'view_config_message': 'Konfigurationsdatei konnte nicht abgerufen werden',
    'view_config_nic': 'Netzwerkkonfiguration',
    'view_config_nic_message': 'Netzwerkkonfigurationsdatei konnte nicht abgerufen werden',
    'view_config_pulseha': 'PulseHA',
    'view_config_pulseha_message': 'Pulse-HA-Konfigurationsdatei konnte nicht abgerufen werden',
    'view_config_rbac': 'RBAC',
    'view_config_routing_table': 'Routing-Tabelle',
    'view_config_routing_table_message': 'Routing-Tabelle Konfigurationsdatei konnte nicht abgerufen werden',
    'view_config_service_ips': 'Dienst-IPs',
    'view_config_sidecar': 'Sidecar',
    'view_config_sips': 'SIPs',
    'view_config_snmp': 'SNMP-Konfiguration',
    'view_config_snmpd_message': 'SNMP-Konfigurationsdatei konnte nicht abgerufen werden',
    'view_config_system': 'System',
    'view_config_unknown': 'Unbekannte Konfiguration',
    'view_config_unknown_message': 'Unbekannte Konfigurationsdatei konnte nicht abgerufen werden.',
    'virtual_service_widget_frontend_overview': 'Frontend-Übersicht',
    'widget_collecting_data': 'Daten werden gesammelt',
    'widget_everything_good': 'Alles sieht gut aus',
    'widget_ha_proxy_message': 'Sie müssen Ha Proxy neu starten, da ALLE Ihre Dienste im Wartezustand sind',
    'widget_no_data_collected': 'keine Daten',
    'widget_no_permission': 'Sie haben keine Berechtigung, dieses Widget anzuzeigen',
    'widget_no_data_error': 'Daten des Widgets können nicht abgerufen werden.',
    'widget_upgrade_options': 'Upgrade-Optionen',
    'wizard_change_template': 'Vorlage ändern',
    'wizard_change_template_text': 'Durch das Ändern der Vorlage werden alle aktuellen Formulardaten gelöscht. Möchten Sie fortfahren?',
    'wizard_leaving_partner_mode': 'Partnermodus verlassen',
    'wizard_leaving_partner_mode_text': 'Sie sind dabei, den Partnermodus zu verlassen. Nachdem Sie auf Bestätigen geklickt haben, können Sie nicht mehr zum Partnermodus zurückkehren. Möchten Sie fortfahren?',
    'wizard_loading': 'Lade Assistent...',
    'wizard_save_template': 'Vorlage speichern',
    'wizard_skip_step': 'Überspringen Sie diesen Schritt',
    'wizard_step_errors': 'Schrittfehler',
    'wizard_submit_button_message': 'Mit dieser Schaltfläche „Senden“ werden alle nachfolgenden Schritte übersprungen. Änderungen, die Sie in diesem Schritt vorgenommen haben, können sich auf andere Schritte auswirken.',
    'wizard_user_template': 'Wählen Sie eine Vorlage von Ihrem lokalen Gerät aus',

// General labels/phrases
    'activate_account': 'Konto aktivieren',
    'adc_access': 'ADC-Zugriff',
    'add_another': 'Weiteres hinzufügen',
    'add_cert': 'Zertifikat hinzufügen',
    'add_cert_upper': 'Zertifikat hinzufügen',
    'add_service': 'Dienst hinzufügen',
    'already_exists': ' existiert bereits.',
    'already_in_use': ' wird bereits verwendet.',
    'at_least_one_required': 'Mindestens eines ist erforderlich.',
    'backups_used': 'Verwendete Backups',
    'cant_be_deleted': 'können nicht gelöscht werden, da sie gerade verwendet werden.',
    'certificate_expired': 'Zertifikat abgelaufen.',
    'cidr_missing': 'Bitte verwenden Sie die CIDR-Notation für das Subnetz. z.B. 127.0.0.1/24',
    'client_connections': 'Clientverbindungen',
    'confirm_email': 'E-Mail bestätigen',
    'confirm_delete': 'Löschen bestätigen',
    'confirm_delete_message': 'Sind Sie sicher, dass Sie löschen möchten ',
    'connection_details': 'Verbindungsdetails',
    'connection_method': 'Verbindungsmethode',
    'connection_options': 'Verbindungsoptionen',
    'contact_number': 'Kontakttelefonnummer',
    'contact_sales': 'Vertrieb kontaktieren',
    'contact_us': 'Kontaktieren Sie uns',
    'copy_output': 'Ausgabe kopieren',
    'create_account': 'Konto erstellen',
    'created_by': 'Erstellt von',
    'database_name': 'Datenbankname',
    'date_just_now': 'Gerade eben',
    'date_time': 'Datum & Uhrzeit',
    'date_time_sys_title': 'Systemdatum & -uhrzeit',
    'delete_backup': 'Backup löschen',
    'delete_backup_message': 'Sind Sie sicher, dass Sie dieses Backup löschen möchten?',
    'delete_group': 'Gruppe löschen',
    'delete_ip': 'IP löschen',
    'delete_ips': 'IPs löschen',
    'delete_user': 'Benutzer löschen',
    'delete_users': 'Benutzer löschen',
    'domain_name': 'Domainname',
    'down_time': 'Ausfallzeit',
    'download_csv': 'CSV herunterladen',
    'downloading': 'Herunterladen',
    'external_weight': 'Externe dynamische Gewichtung',
    'feedback_agent': 'Rückmeldungsagent',
    'feedback_agent_port': 'Rückmeldungsagentenport',
    'feedback_method': 'Rückmeldemethode',
    'file_name': 'Dateiname',
    'file_size': 'Dateigröße',
    'file_type': 'Dateityp',
    'floating_ips': 'Floating IPs',
    'force_logout_message': 'Ihre Einstellungen wurden geändert. Sie müssen sich abmelden, damit diese Änderungen wirksam werden.',
    'force_rollback': 'Erzwingen Rückgängig',
    'force_unlock': 'Erzwingen entsperren',
    'force_upload': 'Hochladen erzwingen',
    'force_upload_message': 'Möchten Sie dennoch mit dem Hochladen fortfahren?',
    'forgot_password': 'Passwort vergessen?',
    'forwarding_mode': 'Weiterleitungsmodus',
    'free_download': 'Kostenloser Download',
    'go_back': 'Zurück',
    'help_loadbalancer': 'Loadbalancer-Hilfe',
    'help_portal': 'Portalhilfe',
    'hidden_columns': 'Versteckte Spalten',
    'host_name': 'Hostname',
    'http_connection': 'HTTP-Verbindung',
    'ip_address': 'IP-Adresse',
    'items_per_page': 'Elemente pro Seite',
    'knowledge_base': 'Wissensdatenbank',
    'last_alert': 'Letzte Warnung',
    'last_checked': 'Zuletzt überprüft',
    'layer_7_advanced': 'Layer 7 erweitert',
    'licence_company_name': 'Firmenname',
    'licence_key': 'Lizenzschlüssel',
    'load_balancer': 'Lastenausgleicher',
    'log_level': 'Log-Level',
    'login_in': 'Anmelden',
    'mac_address': 'MAC-Adresse',
    'max_conns': 'Maximale Verbindungen',
    'maximum_length': 'Die maximale Zeichenlänge beträgt ',
    'minimum_length': 'Die Mindestzeichenlänge beträgt ',
    'name_first': 'Vorname',
    'name_last': 'Nachname',
    'network_address': 'Netzwerkadresse',
    'no_matches': 'Keine Treffer',
    'no_more_content': 'Kein Inhalt mehr',
    'none_set': 'Nicht festgelegt',
    'nothing_configured': 'Nichts konfiguriert.',
    'password_confirm': 'Passwort bestätigen',
    'per_month': 'pro Monat',
    'per_year': 'pro Jahr',
    'polaris lb': 'Polaris LB',
    'polaris topology': 'Polaris-Topologie',
    'product_name': 'Produktname',
    'product_type': 'Produkttyp',
    'read_write': 'Lese-/Schreib',
    'real_servers': 'Echte Server',
    'release_version': 'Versionsnummer',
    'restart_haproxy': 'HaProxy neu starten',
    'save_file': 'Datei speichern',
    'select_all': 'Alle auswählen',
    'service_outage': 'Dienstausfall',
    'service_status': 'Dienststatus',
    'skip_to_finish': 'Zum Ende springen',
    'software_updates': 'Softwareaktualisierungen',
    'ssl_certificate': 'SSL-Zertifikat',
    'ssl_max_version': 'Maximale SSL-Version',
    'ssl_min_version': 'Minimale SSL-Version',
    'ssl_term': 'SSL-Terminierung',
    'start_free_trial': 'Kostenlose Testversion starten',
    'submit_disabled': '„Senden“ ist deaktiviert, da sich das Formular nicht geändert hat.',
    'subnet_add': 'Subnetz hinzufügen',
    'subnet_delete': 'Subnetz löschen',
    'subnet_delete_message': 'Möchten Sie das Subnetz wirklich löschen ',
    'subnet_edit': 'Subnetz bearbeiten',
    'system_control': 'Systemsteuerung',
    'thank_you': 'Vielen Dank',
    'timed_out': 'Zeitüberschreitung',
    'turn_off': 'Ausschalten',
    'upgrade_options': 'Upgrade-Optionen',
    'username_email': 'Benutzername/E-Mail',
    'value_greater_than': 'Der Wert muss größer sein als ',
    'value_less_than': 'Der Wert muss kleiner sein als ',
    'view_config_snmp_conf': 'SNMP-Konfiguration',
    'view_service_status': 'Servicestatus anzeigen',
    'welcome_to_endurance': 'Willkommen bei Endurance',
    'welcome_to_admin_panel': 'Willkommen im Portal Admin',
    'welcome_to_portal': 'Willkommen im Portal',
    'zero_downtime': 'Null Ausfallzeit',

// Single words
    'account': 'Konto',
    'accounts': 'Konten',
    'acl': 'ACL',
    'acls': 'ACLs',
    'action': 'Aktion',
    'activate': 'Aktivieren',
    'active': 'Aktiv',
    'adc': 'ADC',
    'adcs': 'ADCs',
    'add': 'Hinzufügen',
    'address': 'Adresse',
    'adopt': 'Übernehmen',
    'adopted': 'Übernommen',
    'adoption': 'Übernahme',
    'adopting': 'Übernahme',
    'advanced': 'Erweitert',
    'aes': 'AES',
    'ago': 'vor',
    'alerts': 'Warnungen',
    'and': 'Und',
    'apply': 'Anwenden',
    'arch': 'Arch',
    'attention': 'Achtung',
    'authentication': 'Authentifizierung',
    'available': 'verfügbar',
    'back': 'Zurück',
    'backend': 'Backend',
    'backends': 'Backends',
    'backup': 'Backup',
    'backups': 'Backups',
    'billing': 'Abrechnung',
    'bond': 'Bond',
    'break': 'Unterbrechen',
    'builtin': 'Integriert',
    'bytes': 'Bytes',
    'ca': 'CA',
    'cancel': 'Abbrechen',
    'central': 'Zentral',
    'certificate': 'Zertifikat',
    'certificates': 'Zertifikate',
    'certs': 'Zertifikate',
    'change': 'Ändern',
    'chat': 'Chat',
    'cidr': 'CIDR',
    'cipher': 'Chiffre',
    'cipher_usage': 'Chiffrenverwendung',
    'ciphers': 'Chiffren',
    'close': 'Schließen',
    'code': 'Code',
    'collectors': 'Sammler',
    'coming_soon': 'Demnächst',
    'condition': 'Bedingung',
    'config': 'Konfiguration',
    'confirm': 'Bestätigen',
    'conn': 'Verbindung',
    'connect': 'Verbinden',
    'connection': 'Verbindung',
    'connections': 'Verbindungen',
    'contact': 'Kontakt',
    'continue': 'Weiter',
    'copy': 'Kopie',
    'copyright': 'Urheberrecht ©',
    'count': 'Anzahl',
    'create': 'Erstellen',
    'critical': 'Kritisch',
    'crl': 'CRL',
    'csr': 'CSR',
    'database': 'Datenbank',
    'date': 'Datum',
    'day': 'Tag',
    'days': 'Tage',
    'days_upper': 'Tage',
    'debug': 'Debuggen',
    'default': 'Standard',
    'dashboard': 'Dashboard',
    'delete': 'Löschen',
    'des': 'DES',
    'description': 'Beschreibung',
    'details': 'Details',
    'direct': 'Direkt',
    'disabled': 'Deaktiviert',
    'disconnect': 'Trennen',
    'documentation': 'Dokumentation',
    'domain': 'Domain',
    'done': 'Fertig',
    'down': 'Herunter',
    'downgrade': 'Downgrade',
    'download': 'Herunterladen',
    'downloads': 'Downloads',
    'drain': 'Leeren',
    'duplicate': 'Duplizieren',
    'edit': 'Bearbeiten',
    'email': 'E-Mail',
    'enable': 'Aktivieren',
    'enabled': 'Aktiviert',
    'endurance': 'Ausdauer',
    'enforce': 'Erzwingen',
    'enterprise': 'Unternehmen',
    'error': 'Fehler',
    'execute': 'Ausführen',
    'existing': 'Bestehend',
    'expires': 'Verfällt',
    'external': 'Extern',
    'external_privacy': 'Datenschutz',
    'external_terms': 'Bedingungen',
    'failure': 'Versagen',
    'fall': 'Fall',
    'fallback': 'Ausweich',
    'feedback': 'Rückmeldung',
    'file': 'Datei',
    'finish': 'Beenden',
    'fips': 'FIPs',
    'firewall': 'Firewall',
    'for': 'für',
    'forced': 'Erzwungen',
    'format': 'Format',
    'forward': 'Weiterleiten',
    'forwarding': 'Weiterleitung',
    'from': 'Von',
    'frontend': 'Frontend',
    'frontends': 'Frontends',
    'gateway': 'Gateway',
    'general': 'Allgemein',
    'gid': 'GID',
    'granularity': 'Granularität',
    'group': 'Gruppe',
    'groups': 'Gruppen',
    'gslb': 'GSLB',
    'halt': 'Anhalten',
    'haproxy': 'HAProxy',
    'has': 'hat',
    'headers': 'Header',
    'health': 'Gesundheit',
    'healthcheck': 'Gesundheitscheck',
    'high': 'Hoch',
    'hostname': 'Hostname',
    'hour': 'Stunde',
    'hours': 'Stunden',
    'http': 'HTTP',
    'hypervisor': 'Hypervisor',
    'hypervisors': 'Hypervisoren',
    'id': 'ID',
    'if': 'Wenn',
    'import': 'Importieren',
    'in': 'in',
    'information': 'Information',
    'interface': 'Schnittstelle',
    'interfaces': 'Schnittstellen',
    'interval': 'Intervall',
    'ip': 'IP',
    'ips': 'IPs',
    'ipv4': 'IPv4',
    'ipv6': 'IPv6',
    'is': 'Ist',
    'issue': 'Problem',
    'json': 'JSON',
    'kb': 'kB',
    'keyboard': 'Tastatur',
    'keymap': 'Tastaturbelegung',
    'l4': 'Ebene 4',
    'l7': 'Ebene 7',
    'label': 'Bezeichnung',
    'licensing': 'Lizenzierung',
    'lines': 'Linien',
    'list': 'Liste',
    'loading': 'Laden...',
    'local': 'lokal',
    'log': 'Protokoll',
    'logout': 'Abmelden',
    'logs': 'Protokolle',
    'low': 'Niedrig',
    'maintenance': 'Wartung',
    'manage': 'Verwalten',
    'mask': 'Maske',
    'max': 'Max:',
    'md5': 'MD5',
    'medium': 'Mittel',
    'member': 'Mitglied',
    'members': 'Mitglieder',
    'method': 'Methode',
    'minute': 'Minute',
    'minutes': 'Minuten',
    'mode': 'Modus',
    'modes': 'Modi',
    'monitor': 'Überwachung',
    'month': 'Monat',
    'months': 'Monate',
    'more': 'Mehr',
    'ms': '(ms)',
    'n_a': 'n/a',
    'name': 'Name',
    'namespace': 'Namespace',
    'network': 'Netzwerk',
    'new': 'neu',
    'news': 'Nachricht',
    'next': 'Nächste',
    'node': 'Knoten',
    'nodes': 'Knoten',
    'notes': 'Notizen',
    'notification': 'Benachrichtigung',
    'notifications': 'Benachrichtigungen',
    'occurrence': 'Ereignis',
    'of': 'von',
    'off': 'aus',
    'offline': 'Offline',
    'ok': 'Ok',
    'online': 'Online',
    'option': 'Option',
    'optional': 'optional',
    'options': 'Optionen',
    'or': 'Oder',
    'order': 'Reihenfolge',
    'organization': 'Organisation',
    'organizations': 'Organisationen',
    'overview': 'Übersicht',
    'passive': 'Passiv',
    'password': 'Passwort',
    'paths': 'Pfade',
    'pending': 'Ausstehend',
    'percentage': '%',
    'permission': 'Erlaubnis',
    'persistence': 'Persistenz',
    'place': 'Ort',
    'places': 'Orte',
    'platform': 'Plattform',
    'pools': 'Pools',
    'port': 'Port',
    'portal': 'Portal',
    'ports': 'Ports',
    'primary': 'Primär',
    'priority': 'Priorität',
    'product': 'Produkt',
    'products': 'Produkte',
    'prometheus': 'Prometheus',
    'protocol': 'Protokoll',
    'provider': 'Anbieter',
    'proxy': 'Proxy',
    'purchase': 'Kaufen',
    'range': 'Bereich',
    'rbac': 'RBAC',
    'read': 'Lesen',
    'ready': 'Bereit',
    'recovery': 'Wiederherstellung',
    'references': 'Verweise',
    'region': 'Region',
    'regions': 'Regionen',
    'reload': 'Neu laden',
    'relogin': 'Erneut anmelden',
    'remove': 'Entfernen',
    'renew': 'Erneuern',
    'repeat': 'Wiederholen',
    'replace': 'Ersetzen',
    'reply': 'Antworten',
    'reports': 'Berichte',
    'reset': 'Zurücksetzen',
    'resources': 'Ressourcen',
    'restart': 'Neustart',
    'restore': 'Wiederherstellen',
    'rise': 'Anstieg',
    'role': 'Rolle',
    'roles': 'Rollen',
    'routing': 'Routing',
    'rows': 'Zeilen',
    'rules': 'Regel(n)',
    'save': 'Speichern',
    'schedule': 'Zeitplan',
    'schedules': 'Zeitpläne',
    'search': 'Suche',
    'search_placeholder': 'Suchen...',
    'second': 'Sekunde',
    'secondary': 'Sekundär',
    'seconds': 'Sekunden',
    'section': 'Abschnitt',
    'select': 'Auswählen',
    'selected': 'ausgewählt',
    'send': 'Senden',
    'serial': 'Seriennummer',
    'server': 'Server',
    'service': 'Dienst',
    'services': 'Dienste',
    'settings': 'Einstellungen',
    'setup': 'Einrichtung',
    'sha': 'SHA',
    'shutdown': 'Herunterfahren',
    'shuttle': 'Shuttle',
    'sidecar': 'Sidecar',
    'sips': 'SIPs',
    'size': 'Größe',
    'size_b': 'Größe (B)',
    'size_kb': 'Größe (kB)',
    'size_mb': 'Größe (MB)',
    'smtp': 'SMTP',
    'snmp': 'SNMP',
    'speed': 'Geschwindigkeit',
    'ssl': 'SSL',
    'start': 'Start',
    'state': 'Zustand',
    'status': 'Status',
    'step': 'Schritt',
    'storage': 'Speicher',
    'subject': 'Betreff',
    'submit': 'Absenden',
    'subnet': 'Subnetz',
    'subnets': 'Subnetze',
    'subscription': 'Abonnement',
    'subscriptions': 'Abonnements',
    'success': 'Erfolg',
    'successful': 'erfolgreich',
    'system': 'System',
    'tcp': 'TCP',
    'teams': 'Teams',
    'templates': 'Vorlagen',
    'tertiary': 'Tertiär',
    'theme': 'Thema',
    'then': 'Dann',
    'tier': 'Stufe',
    'tiers': 'Ebenen',
    'time': 'Zeit',
    'to': 'zu',
    'to_upper': 'Zu',
    'today': 'Heute',
    'token': 'Zeichen',
    'topologies': 'Topologien',
    'total': 'insgesamt',
    'ttl': 'TTL',
    'type': 'Typ',
    'unlimited': 'Unbegrenzt',
    'up': 'Hoch',
    'update': 'Aktualisieren',
    'updating': 'Aktualisierung',
    'upgrade': 'Upgrade',
    'upload': 'Hochladen',
    'usage': 'Verwendung',
    'user': 'Benutzer',
    'username': 'Benutzername',
    'users': 'Benutzer',
    'valid_to': 'Gültig bis',
    'value': 'Wert',
    'vendor': 'Hersteller',
    'verify': 'Überprüfen',
    'version': 'Version',
    'via': 'Über',
    'view': 'Ansehen',
    'vlan': 'VLAN',
    'vlans': 'VLANs',
    'warning': 'Warnung',
    'warp': 'Warp',
    'weight': 'Gewicht',
    'welcome': 'Willkommen',
    'with': 'mit',
    'year': 'Jahr',
    'years': 'Jahre',
    'zero': 'Null',

    // Subscription page
    'adc_backups': 'ADC-Sicherungen',
    'online_updates': 'Online-Updates',
    'asset_scheduling': 'Asset-Planung',
    'dedicated_success_manager': 'Dedizierter Erfolgsmanager',
    'professional_services': 'Professionelle Dienstleistungen',
    'secure_direct_access': 'Sicherer Direktzugriff',
    'secure_warp_remote_access': 'Sicherer Warp-Fernzugriff',
    'adc_security_insights': 'ADC-Sicherheitsinformationen',
    'adc_certificate_insights': 'ADC-Zertifikatsinformationen',
    'single_sign_on': 'Einmalanmeldung (G Suite + Azure AD)',
    'single_sign_on_tailored': 'Einmalanmeldung (G Suite + Azure AD + SAML)',
    '2fa': 'Zwei-Faktor-Authentifizierung (SMS + APP)',
    'audit_log': 'Prüfprotokoll',
    'license_management': 'Lizenzverwaltung',
    'api_access': 'API-Zugriff',
    'asset_scheduling_pipelines': 'Anlagenplanung – Pipelines',
    'white_label': 'Weißes Etikett',

    // TODO remove when RBAC complete
    'user_invite_new': 'Benutzer einladen',
    'user_permissions': 'Benutzerberechtigungen',

    // Validation messages.
    'base_64_not_found': 'BASE64 kann nicht gefunden werden',
    'domain_validation_error': 'Ungültiger Domainname. Bitte stellen Sie sicher, dass Folgendes zutrifft: ' +
        '<ul>\n' +
        '<li>Der Domainname enthält nur alphanumerische Zeichen, Bindestriche oder Punkte <br>und beginnt sowie endet mit einem alphanumerischen Zeichen.</li>\n' +
        '<li>Der Domainname überschreitet nicht die maximale Gesamtlänge von 253 Zeichen.</li>\n' +
        '<li>Jedes Label (Teil des Domainnamens, getrennt durch Punkte) ist zwischen 1 und 63 Zeichen lang.</li>\n' +
        '<li>Leerzeichen oder Sonderzeichen sind nicht erlaubt (außer Bindestriche und Punkte).</li>\n' +
        '</ul>',
    'duplicate_adc_label': 'Ein ADC mit diesem Label existiert bereits.',
    'duplicate_already_in_use': 'Duplikat. Bereits in Verwendung.',
    'duplicate_certificate_label': 'Ein Zertifikat mit diesem Label existiert bereits.',
    'duplicate_cipher_list': 'Eine Chiffliste mit diesem Label existiert bereits.',
    'duplicate_fip': 'Doppelte Floating-IP-Adresse',
    'duplicate_global_name': 'Ein globaler Name mit diesem Label existiert bereits.',
    'duplicate_group_ip': 'Diese IP ist bereits einer anderen Gruppe zugewiesen.',
    'duplicate_group_name': 'Doppelter Gruppenname',
    'duplicate_header_name_type': 'Eine Kopfzeile mit diesem Namen und Typ existiert bereits.',
    'duplicate_hostname': 'Dieser Hostname existiert bereits.',
    'duplicate_member_prefix': 'Ein Mitglied mit diesem ',
    'duplicate_name': 'Dieser Name wird bereits verwendet.',
    'duplicate_namespace': 'Dieser Namespace existiert bereits.',
    'duplicate_pool': 'Ein Pool mit diesem Namen existiert bereits.',
    'duplicate_port': 'Doppelter Port',
    'duplicate_role_name': 'Doppelter Rollenname.',
    'duplicate_route': 'Diese Route wird bereits verwendet.',
    'duplicate_sip': 'Doppelte statische IP-Adresse',
    'duplicate_subnet': 'Doppeltes Subnetz',
    'duplicate_value': 'Dies ist ein doppelter Wert.',
    'email_in_use': 'Ein Benutzer mit dieser E-Mail existiert bereits.',
    'email_mismatch': 'Bestätigen Sie, dass die E-Mail-Adresse nicht mit der E-Mail-Adresse übereinstimmt.',
    'file_extension_not_found': 'Dateierweiterung kann nicht gefunden werden.',
    'headers_invalid_text': `Die L7-Header-Textfelder dürfen keine ungültigen Zeichen enthalten.<br>
        <ul>
        <li>Erlaubt</li>
        <ul>
        <li>application/json</li>
        <li>text/html; charset=utf-8</li>
        <li>Mon, 27 Jul 2009 12:28:53 GMT</li>
        <li>  Wert mit Leerzeichen  </li>
        <li>\\t Steuerzeichen</li>
        </ul>
        <li>Nicht Erlaubt</li>
        <ul>
        <li>∑ Unicode-Zeichen €</li>
        <li>\\u001F Steuerzeichen</li>
        <li>\\n \\r Steuerzeichen</li>
        </ul>
        </ul>`,
    'hostname_validation_error_message': 'Ungültiger Hostname. Bitte stellen Sie sicher, dass Folgendes zutrifft: <br>\n' +
        '<ul>\n' +
        '<li>Der Hostname enthält nur alphanumerische Zeichen und Bindestriche (-).</li>\n' +
        '<li>Er muss mit einem alphanumerischen Zeichen beginnen und enden.</li>\n' +
        '<li>Die Gesamtlänge des Hostnamens darf 253 Zeichen nicht überschreiten.</li>\n' +
        '<li>Hostnamen dürfen nicht ausschließlich numerisch sein und müssen mindestens ein alphabetisches Zeichen enthalten.</li>\n' +
        '<li>Leerzeichen, Sonderzeichen und Unterstriche (_) sind nicht erlaubt.</li>\n' +
        '<li>Hostnamen sind nicht case-sensitiv (Groß- und Kleinschreibung wird nicht unterschieden).</li>\n' +
        '</ul>',
    'incorrect_password': 'Falsches Passwort.',
    'invalid_card_number': 'Ungültige Kartennummer',
    'invalid_certificate': 'Ungültiges Zertifikat.',
    'invalid_cidr': 'Ungültiger CIDR.',
    'invalid_email_address': 'Ungültige E-Mail-Adresse.',
    'invalid_email_address_length': 'Ungültige E-Mail-Adresse, zu lang',
    'invalid_file_type': 'Der Dateiupload muss die Erweiterung .pem oder .pfx haben.',
    'invalid_integer': 'Wert ist keine gültige Zahl',
    'invalid_ip': 'Ungültige IP-Adresse.',
    'invalid_ip_cidr': 'Bitte verwenden Sie die korrekte Notation für IP/CIDR, z. B. 127.0.0.1/24.',
    'invalid_ip_domain': 'Ungültige IP-Adresse oder Domain.',
    'invalid_ipv4': 'Ungültige IPv4-Adresse.',
    'invalid_ipv6': 'Ungültige IPv6-Adresse.',
    'invalid_ip_long': `Die IP-Adresse ist ungültig. Bitte stellen Sie sicher, dass sie im gültigen IPv4- oder IPv6-Format vorliegt.<br>
                Eine IPv4-Adresse muss:<br>
                <ul>
                <li>4 Zahlen enthalten, die durch Punkte getrennt sind  </li>
                 <li>Jede Zahl muss zwischen 0 und 255 liegen  </li>
                 <li> Darf nicht mit 0 beginnen </li>
                 </ul>
                Eine IPv6-Adresse muss enthalten:<br>
                <ul>
                <li>8 Gruppen von hexadezimalen Ziffern, die durch Doppelpunkte getrennt sind.</li>
                <li>Jede hexadezimale Ziffer muss zwischen 0 und 65535 liegen</li>
                </ul>`,
    'invalid_ip_or_domain': 'Ungültige Domain oder IP-Adresse.',
    'invalid_name_characters': 'Ungültige Zeichen. Sollte nur eine Kombination aus enthalten: a-z A-Z 0-9_- {} [] () . , \' und Leerzeichen',
    'invalid_name_start_space': 'Namen dürfen nicht mit einem Leerzeichen beginnen.',
    'invalid_name_length': 'Feldlänge zu lang. Sollte weniger als 253 Zeichen sein.',
    'invalid_name_length_short': 'Feldlänge zu kurz. Sollte mehr als 2 Zeichen lang sein.',
    'invalid_passcode': 'Ungültiger Code. Bitte versuchen Sie es erneut.',
    'invalid_password_simple': 'Ungültiges Passwort. Das Passwort muss mindestens 8 Zeichen lang sein, 1 Großbuchstaben, 1 Zahl, 1 Kleinbuchstaben enthalten und darf keine Sonderzeichen enthalten, z. B. !&$£@',
    'invalid_password_complex': 'Ungültiges Passwort. Das Passwort muss zwischen 8 und 128 Zeichen lang sein und einen Großbuchstaben, eine Ziffer, einen Kleinbuchstaben und ein Sonderzeichen enthalten. Zu den Sonderzeichen gehört !@#$%^&£?*-',
    'invalid_path_end': 'Das Ende des Pfads muss mit einem \'.\' beginnen',
    'invalid_path_start': 'Der Pfad sollte mit einem Schrägstrich beginnen: /',
    'invalid_phone_number': 'Ungültige Telefonnummer. Das + ist optional, aber die erste Ziffer sollte 1-9 sein, gefolgt von bis zu 14 Ziffern (0-9).',
    'invalid_port_range': 'Ungültiger Port. Der Portbereich muss zwischen 1 und 65535 liegen',
    'invalid_redirect_location': 'Ungültige Umleitungsadresse.',
    'invalid_san': 'Ungültiger SAN. Akzeptierte Formate sind IP-Adressen, E-Mail-Adressen, Domains und Subdomains.',
    'invalid_start_time': 'Die Startzeit darf nicht in der Zukunft liegen.',
    'invalid_time_unit': 'Ungültige Zeiteinheit, sollte sein: us/ms/s/m/h/d',
    'l7_mode_reset_error': 'Dieses Feld wurde zurückgesetzt, da sich der Modus geändert hat und der vorherige Wert nicht mit dem aktuellen Modus kompatibel war.',
    'label_in_use': 'Dieses Label wird bereits verwendet.',
    'multiport_invalid_format': 'Ungültiges Portformat. Ports sollten zwischen 0-9 sein. Trennzeichen: , oder -',
    'multiport_out_of_range': 'Ungültiger Port. Nicht zwischen 1 und 65535',
    'no_logs_before': 'Es gibt keine Protokolle vor ',
    'password_mismatch': 'Passwort stimmt nicht überein.',
    'port_none_checked_error': 'Mindestens eine Portoption muss ausgewählt sein.',
    'port_range_overlap': 'Dieser Bereich überschneidet sich mit einem anderen.',
    'url_validation': 'Ungültige URL'
};
